import React, { useEffect, useRef, useState, useId, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  ListGroup,
 
  Spinner,
  Form,
  Modal,
  FormGroup,
  FormLabel,
  Alert,
  Badge,
  Dropdown,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { Button, DataTable, ActionButton } from "./ui";
import { api } from "../services";
import { MDBContainer } from "mdb-react-ui-kit";
import PriceDisplay from "./PriceDisplay";
import ProductAppPricePanel from "./ProductAppPricePanel";
import { getImageUrl } from "../utils/utils";
import "./product.css";
import { useMediaQuery } from "react-responsive";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Check, ImageIcon, MoveDown, X } from "lucide-react";
import UpdateProductModal from "./Modals/UpdateProductModal"
import { useTranslation } from "react-i18next";
import DeleteModal from "./Modals/DeleteModal";
import { usePermission } from "../hooks/usePermission";
import { RBAC_MODULES, PERMISSION_ACTIONS } from "../config/routePermissions";
import { getLocalizedDisplayText } from "../utils/arabicTranslationUtils";
import { LocalizedReadOnlyText } from "./MissingTranslationBadge";
import {
  resolveDateLocale,
  formatLocalizedDateTime,
} from "../utils/formatDateTime";
import {
  resolveProductApiError,
  translateProductApiMessage,
} from "../utils/translateProductApiMessage";
import { fetchPricedAppSources, getUniqueConnectedDeliveryApps } from "../utils/productAppPrice";
import { handlePlatformLogoError, resolvePlatformLogo } from "../utils/platformLogos";
import { isPosReadOnlyEntity, posReadOnlyTooltip } from "../utils/posReadOnly";

 const supportedPlatforms = [
    { id: 1, name: "Jahez", nameAr: "جاهز", key: "jahez", status: "supported" },
  ];

  const unsupportedPlatforms = [
    { id: 1, name: "Keeta", nameAr: "كيتا", key: "keeta", status: "unsupported" },
    { id: 2, name: "Ninja", nameAr: "نينجا", key: "ninja", status: "unsupported" },
  ];
const Product = () => {
  const { t,i18n } = useTranslation("translation");
  const isArabic = i18n.language === 'ar'
  const dateLocale = resolveDateLocale(i18n.language);
  const localizedDisplay = (enVal, arVal, field = "title") =>
    getLocalizedDisplayText(enVal, arVal, isArabic, field);
  const localizedNameDisplay = (nameObj, field = "title") =>
    localizedDisplay(nameObj?.en, nameObj?.ar, field);
  const localizedNameText = (nameObj, field = "title") =>
    localizedNameDisplay(nameObj, field).text;
  const localizedAllergenLabel = (allergen) => {
    if (!allergen) return "";
    return localizedDisplay(allergen.name, allergen.name_localized, "title").text;
  };
  const localizedOptionDisplay = (option) =>
    localizedDisplay(option?.nameEn, option?.nameAr, "title");
  const localizedOptionDescriptionDisplay = (option) =>
    localizedDisplay(option?.descriptionEn, option?.descriptionAr, "description");
  const { id } = useParams();
  const navigate = useNavigate();
  const { can, canAny } = usePermission();
  const canEditProduct = can(RBAC_MODULES.PRODUCTS, PERMISSION_ACTIONS.EDIT);
  const canDeleteProduct = can(RBAC_MODULES.PRODUCTS, PERMISSION_ACTIONS.DELETE);
  const canMutateCatalogLink = canAny([
    [RBAC_MODULES.PRODUCTS, PERMISSION_ACTIONS.EDIT],
    [RBAC_MODULES.CATALOG, PERMISSION_ACTIONS.EDIT],
  ]);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleteModifierTarget, setDeleteModifierTarget] = useState(null);
  const [state, setState] = useState({
    product: null,
    loading: true,
    error: null,
    selectedModifiers: {},
    showOptionModal: false,
    showModifierModal: false,
    showEditModifierModal: false,
    showEditOptionModal: false,
    currentModifier: null,
    editingModifier: null,
    editingOption: null,
    newOption: {
      nameEn: "",
      nameAr: "",
      descriptionEn: "",
      descriptionAr: "",
      price: "",
      calories: "",
    },
    editOption: {
      nameEn: "",
      nameAr: "",
      descriptionEn: "",
      descriptionAr: "",
      price: "",
      calories: "",
    },
    newModifier: {
      name: { en: "", ar: "" },
      is_multiple: false,
      is_radio: false,
      max_option: 1,
      min_option: 0,
    },
    editModifier: {
      name: { en: "", ar: "" },
      is_multiple: false,
      is_radio: false,
      max_option: 1,
      min_option: 0,
    },
    successMessage: null,
  });
  const modalRef = useRef(null);
  const editModalRef = useRef(null);
  const permTipId = useId();
  const [selectedImage, setSelectedImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [heroImageFailed, setHeroImageFailed] = useState(false);
  useEffect(() => {
    setHeroImageFailed(false);
  }, [previewUrl, state.product?.image_path]);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadStatus, setUploadStatus] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDeleteModifierModal, setShowDeleteModifierModal] = useState(false);
  const [selectedCatalogId, setSelectedCatalogId] = useState(null);
  const [showProductDeleteModal,setShowProductDeleteModal] = useState(false);
const [nutritionFields, setNutritionFields] = useState([]);
const [accountApps, setAccountApps] = useState([]);
const [addonApps, setAddonApps] = useState([]);
const deliveryApps = useMemo(
  () => getUniqueConnectedDeliveryApps(accountApps, addonApps),
  [accountApps, addonApps]
);
const [nutritionFact, setNutritionFact] = useState({
    calories: "",
  calories_kcal: "",
  protein_g: "",
  carbohydrates_g: "",
  totalFat_g: "",
  saturatedFat_g: "",
  transFat_g: "",
  cholesterol_mg: "",
  fiber_g: "",
  totalSugar_g: "",
  addedSugar_g: "",
  salt_g: "",
  sodium_mg: "",
  caffeine_mg: "",
  allergen_ids: [],
  is_salty: false,
  has_caffeine: false
})
console.log("nutritionFields:", nutritionFields);


const [nutritionFacts, setNutritionFacts] = useState({
  calories: "",
  calories_kcal: "",
  protein_g: "",
  carbohydrates_g: "",
  totalFat_g: "",
  saturatedFat_g: "",
  transFat_g: "",
  cholesterol_mg: "",
  fiber_g: "",
  totalSugar_g: "",
  addedSugar_g: "",
  salt_g: "",
  sodium_mg: "",
  caffeine_mg: "",
  allergen_ids: [],
  is_salty: false,
  has_caffeine: false
});
const handleModalClose = () => {
  setShowNutritionModal(false);
  fetchProduct()
}



  const [allergens, setAllergens] = useState([]);
  const [showEditAvailabilityModal, setShowEditAvailabilityModal] =
    useState(false);
  const [editAvailability, setEditAvailability] = useState(null);
  const [deleteSuccess, setDeleteSuccess] = useState(null);
  const [deleteError, setDeleteError] = useState(null);
  const [removeCatalogSuccess, setRemoveCatalogSuccess] = useState(null);
  const [removeCatalogError, setRemoveCatalogError] = useState(null);
  const [availabilityLoading, setAvailabilityLoading] = useState(false);
  const [nutritionLoading, setNutritionLoading] = useState(false);
  

  const defaultAvailability = {
    monday: { is_visible: true, times: [{ start: "00:00", end: "23:59" }] },
    tuesday: { is_visible: true, times: [{ start: "00:00", end: "23:59" }] },
    wednesday: { is_visible: true, times: [{ start: "00:00", end: "23:59" }] },
    thursday: { is_visible: true, times: [{ start: "00:00", end: "23:59" }] },
    friday: { is_visible: true, times: [{ start: "00:00", end: "23:59" }] },
    saturday: { is_visible: true, times: [{ start: "00:00", end: "23:59" }] },
    sunday: { is_visible: true, times: [{ start: "00:00", end: "23:59" }] },
  };
const [isOptionModalVisible, setIsOptionModalVisible] = useState(false);
 const [isEditModalVisible, setIsEditModalVisible] = useState(false);
const [showNutritionModal, setShowNutritionModal] = useState(false);
const [allergenQuantities, setAllergenQuantities] = useState({});
const [modalBodyEl, setModalBodyEl] = useState(null);
const [atBottom, setAtBottom] = useState(false);
const [fieldErrors, setFieldErrors] = useState({});

useEffect(() => {
  if (!modalBodyEl) return;

  const handleScroll = () => {
    const { scrollTop, clientHeight, scrollHeight } = modalBodyEl;
    const threshold = 60;
    const isAtBottom = scrollTop + clientHeight >= scrollHeight - threshold;
    setAtBottom(isAtBottom);
  };

  modalBodyEl.addEventListener('scroll', handleScroll);
  handleScroll(); // run once immediately

  return () => modalBodyEl.removeEventListener('scroll', handleScroll);
}, [modalBodyEl]);



// Close modal when clicking outside
const handleOverlayClick = (e) => {
  if (e.target === e.currentTarget) {
    setShowNutritionModal(false);
    fetchProduct();
  }
};

const fetchProduct = async () => {
  try {
    setIsUploading(false);
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
      return;
    }

    setState((prev) => ({ ...prev, loading: true }));

    const response = await api.get(`/product/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const nf = response.data.product.nutrition_facts || {};

    const initialFacts = {
      calories: nf.calories ?? "",
      calories_kcal: nf.calories_kcal ?? "",
      protein_g: nf.protein_g ?? "",
      carbohydrates_g: nf.carbohydrates_g ?? "",
      totalFat_g: nf.totalFat_g ?? "",
      saturatedFat_g: nf.saturatedFat_g ?? "",
      transFat_g: nf.transFat_g ?? "",
      cholesterol_mg: nf.cholesterol_mg ?? "",
      fiber_g: nf.fiber_g ?? "",
      totalSugar_g: nf.totalSugar_g ?? "",
      addedSugar_g: nf.addedSugar_g ?? "",
      salt_g: nf.salt_g ?? "",
      sodium_mg: nf.sodium_mg ?? "",
      caffeine_mg: nf.caffeine_mg ?? "",
      allergen_ids: nf.allergen_ids ?? [],
      is_salty: nf.is_salty ?? false,
      has_caffeine: nf.has_caffeine ?? false,
    };

    setNutritionFacts(initialFacts);
    setNutritionFact(initialFacts)
    setState((prev) => ({
      ...prev,
      product: response.data.product,
      loading: false,
      error: null,
    }));

    setDeleteSuccess(null);
    setDeleteError(null);
  } catch (error) {
    setState((prev) => ({
      ...prev,
      error: error.response?.data?.message || `${t("Failed to fetch product")}`,
      loading: false,
    }));
  }
};
useEffect(() => {
  const fetchInitialData = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/login");
        return;
      }

      // Fetch nutritional schema
      const schemaRes = await api.get("/nutritional-facts-schema", {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (
        schemaRes.data?.success &&
        Array.isArray(schemaRes.data.data.schema)
      ) {
        setNutritionFields(schemaRes.data.data.schema);
      } else {
        setNutritionFields([]);
      }

      // Fetch allergens
      const allergensRes = await api.get("/allergens", {
        headers: { Authorization: `Bearer ${token}` },
      });

      setAllergens(allergensRes.data.allergens || []);

      try {
        const { apps: nextApps, addonApps: nextAddonApps } =
          await fetchPricedAppSources();
        setAccountApps(nextApps);
        setAddonApps(nextAddonApps);
      } catch (appsErr) {
        console.error("Failed to fetch apps:", appsErr);
      }

      // Fetch product (external function)
      await fetchProduct();
    } catch (err) {
      console.error("Failed to fetch initial data:", err);
      setNutritionFields([]);
      setAllergens([]);
      setState((prev) => ({
        ...prev,
        error:
          err.response?.data?.message || `${t("Failed to fetch initial data")}`,
        loading: false,
      }));
    }
  };

  fetchInitialData();
}, [id, navigate]);


const [showProductModal, setShowProductModal] = useState(false);

console.log("show product modal:", showProductModal);

useEffect(() => {
  if (nutritionFields.length === 0 || !state.product?.nutrition_facts) return;

  const nf = state.product.nutrition_facts;
  const dynamicFacts = {};

  nutritionFields.forEach((field) => {
    dynamicFacts[field.name] = nf[field.name] ?? "";
  });

  // Boolean fields fallback
  dynamicFacts["is_salty"] = nf.is_salty ?? false;
  dynamicFacts["has_caffeine"] = nf.has_caffeine ?? false;
  dynamicFacts["allergen_ids"] = nf.allergen_ids ?? [];

  setNutritionFacts(dynamicFacts);
}, [nutritionFields, state.product]);
// Handle allergen selection
const handleAllergenClick = (allergenId, e) => {
  if (e.target.classList.contains('quantity-input')) return;
  
  const isSelected = nutritionFacts.allergen_ids.includes(allergenId);
  
  if (isSelected) {
    // Remove allergen
    setNutritionFacts(prev => ({
      ...prev,
      allergen_ids: prev.allergen_ids.filter(id => id !== allergenId)
    }));
    setAllergenQuantities(prev => {
      const updated = { ...prev };
      delete updated[allergenId];
      return updated;
    });
  } else {
    // Add allergen
    setNutritionFacts(prev => ({
      ...prev,
      allergen_ids: [...prev.allergen_ids, allergenId]
    }));
  }
};

// Handle quantity change
const handleQuantityChange = (allergenId, quantity) => {
  setAllergenQuantities(prev => ({
    ...prev,
    [allergenId]: quantity
  }));
};

const handleNutritionChange = (e) => {
  const { name, value, type, checked } = e.target;

  if (type === "checkbox") {
    setNutritionFacts((prev) => ({ ...prev, [name]: checked }));
  } else {
    // Block negative and sanitize to 4 decimal places
    let sanitizedValue = value.replace(/[^0-9.]/g, ""); // Remove invalid characters
    if (sanitizedValue.includes(".")) {
      const [intPart, decimalPart] = sanitizedValue.split(".");
      sanitizedValue = intPart + "." + (decimalPart || "").slice(0, 4);
    }

    setNutritionFacts((prev) => ({ ...prev, [name]: sanitizedValue }));
  }
};


const handleSaveNutrition = async () => {
  setNutritionLoading(true);
  try {
    const token = localStorage.getItem("token");
    
    // Include quantity data in the payload
    const payload = {
      ...nutritionFacts,
    };
    
    const response = await api.patch(`/product/${id}/nutrition`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if(response.status === 200) {
      toast.success(
        translateProductApiMessage(response.data.message, t) ||
          t("productApiMsgs.nutritionUpdated")
      )
    }
   
    setShowNutritionModal(false);
    await fetchProduct();
  } catch (error) {
    toast.error(
      resolveProductApiError(error, t, "Failed to update nutrition facts")
    );
    setState((prev) => ({
      ...prev,
      error: error.response?.data?.message || `${t("Failed to update nutrition facts")}`,
    }));
  } finally {
    setNutritionLoading(false);
  }
};
  useEffect(() => {
    if (state.showEditOptionModal) {
      setIsEditModalVisible(true);
    } else {
      const timeout = setTimeout(() => setIsEditModalVisible(false), 300);
      return () => clearTimeout(timeout);
    }
  }, [state.showEditOptionModal]);
useEffect(() => {
  if (state.showOptionModal) {
    setIsOptionModalVisible(true);
  } else {
    const timeout = setTimeout(() => setIsOptionModalVisible(false), 300); // match CSS duration
    return () => clearTimeout(timeout);
  }
}, [state.showOptionModal]);
  // Responsive hook for mobile/tablet

  


  const closeEditModal = () => {
  setState((prev) => ({
    ...prev,
    showEditOptionModal: false,
    errors: {},
  }));
};
useEffect(() => {
  const handleOutsideClick = (e) => {
    if (editModalRef.current && !editModalRef.current.contains(e.target)) {
      closeEditModal();
    }
  };

  if (state.showEditOptionModal) {
    document.addEventListener("mousedown", handleOutsideClick);
  }

  return () => {
    document.removeEventListener("mousedown", handleOutsideClick);
  };
}, [state.showEditOptionModal]);

  const closeModal = () => {
    setState((prev) => ({
      ...prev,
      showOptionModal: false,
      errors: {},
    }));
  };
    useEffect(() => {
    const handleOutsideClick = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        closeModal();
      }
    };

    if (state.showOptionModal) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [state.showOptionModal]);







  const handleModifierChange = (modifierId, optionId, isChecked) => {
    setState((prev) => {
      const modifier = prev.product.modifiers.find((m) => m.id === modifierId);
      let updatedSelection;

      if (modifier.is_radio) {
        updatedSelection = {
          ...prev.selectedModifiers,
          [modifierId]: [optionId],
        };
      } else {
        const currentOptions = prev.selectedModifiers[modifierId] || [];
        updatedSelection = {
          ...prev.selectedModifiers,
          [modifierId]: isChecked
            ? [...currentOptions, optionId]
            : currentOptions.filter((id) => id !== optionId),
        };
      }

      return { ...prev, selectedModifiers: updatedSelection };
    });
  };

  const handleAddOptionClick = (modifier) => {
    setState((prev) => ({
      ...prev,
      currentModifier: modifier,
      showOptionModal: true,
      newOption: {
        nameEn: "",
        nameAr: "",
        descriptionEn: "",
        descriptionAr: "",
        price: "",
        calories: "",
      },
    }));
  };

  const isValidPositiveNumber = (val) => {
    // Allow only numbers > 0, with optional decimals, no negatives, no letters, no multiple dots
    return /^((?!0+(?:\.0+)?$)\d*(?:\.\d+)?$)/.test(val) && Number(val) > 0;
  };

const handleOptionInputChange = (e) => {
  const { name, value } = e.target;
  let newValue = value;
  let updatedErrors = { ...state.errors };

  // English name validation
  if (name === "nameEn") {
    if (!value.trim()) {
      updatedErrors.nameEn = t("English name is required.");
    } else if (!/^[a-zA-Z0-9\s]*$/.test(value)) {
      updatedErrors.nameEn = t("English name must only contain English letters and numbers.");
    } else {
      delete updatedErrors.nameEn;
    }
  }

  // Arabic name validation
  if (name === "nameAr") {
    if (!value.trim()) {
      updatedErrors.nameAr = t("Arabic name is required.");
    } else if (!/^[\u0600-\u06FF0-9\s]*$/.test(value)) {
      updatedErrors.nameAr = t("Arabic name must only contain Arabic letters and numbers.");
    } else {
      delete updatedErrors.nameAr;
    }
  }

  // English description validation
  if (name === "descriptionEn") {
    if (!value.trim()) {
      updatedErrors.descriptionEn = t("English description is required.");
    } else if (!/^[a-zA-Z0-9\s]*$/.test(value)) {
      updatedErrors.descriptionEn = t("English description must only contain English letters and numbers.");
    } else {
      delete updatedErrors.descriptionEn;
    }
  }

  // Arabic description validation
  if (name === "descriptionAr") {
    if (!value.trim()) {
      updatedErrors.descriptionAr = t("Arabic description is required.");
    } else if (!/^[\u0600-\u06FF0-9\s]*$/.test(value)) {
      updatedErrors.descriptionAr = t("Arabic description must only contain Arabic letters and numbers.");
    } else {
      delete updatedErrors.descriptionAr;
    }
  }

  // Price validation
  if (name === "price") {
    // Limit to 2 decimal places
    if (newValue.includes('.')) {
      const parts = newValue.split('.');
      if (parts[1] && parts[1].length > 2) {
        newValue = parts[0] + '.' + parts[1].substring(0, 2);
      }
    }
    
    if (newValue === "") {
      updatedErrors.price = t("Price is required.");
    } else if (!/^\d+(\.\d{0,2})?$/.test(newValue)) {
      updatedErrors.price = t("Please enter a valid price (e.g., 5.99).");
    } else if (Number(newValue) < 0) {
      updatedErrors.price = t("Price must be at least 0 SAR.");
    } else {
      delete updatedErrors.price;
    }
  }

  // Calories validation - only validate if value is provided
  if (name === "calories") {
    if (newValue === "") {
      // No validation error for empty calories
      delete updatedErrors.calories;
    } else if (/^\d+$/.test(newValue) && !isNaN(newValue) && Number(newValue) >= 0) {
      delete updatedErrors.calories;
    } else {
      updatedErrors.calories = t("Calories must be a valid integer.");
    }
  }

  // Generic cleanup for other fields
  if (!["nameEn", "nameAr", "descriptionEn", "descriptionAr", "price", "calories"].includes(name)) {
    if (value.trim()) {
      delete updatedErrors[name];
    } else {
      updatedErrors[name] = t("This field is required.");
    }
  }

  setState((prev) => ({
    ...prev,
    newOption: {
      ...prev.newOption,
      [name]: newValue,
    },
    errors: updatedErrors,
  }));
};





  // Add Option: prevent only spaces and trim on blur
  const handleOptionNameBlur = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({
      ...prev,
      newOption: {
        ...prev.newOption,
        [name]: value.trim(),
      },
    }));
  };

 const handleAddOptionSubmit = async () => {
  const { nameEn, nameAr, descriptionEn, descriptionAr, price, calories } = state.newOption;
  let newErrors = {};

 // Basic validation
if (!nameEn.trim()) newErrors.nameEn = `${t("English name is required.")}`;
if (!nameAr.trim()) newErrors.nameAr = `${t("Arabic name is required.")}`;
if (!descriptionEn.trim()) newErrors.descriptionEn = `${t("English description is required.")}`;
if (!descriptionAr.trim()) newErrors.descriptionAr = `${t("Arabic description is required.")}`;

// Additional character validation
if (nameEn.trim() && !/^[a-zA-Z0-9\s]*$/.test(nameEn)) {
  newErrors.nameEn = `${t("English name must only contain English letters and numbers.")}`;
}
if (nameAr.trim() && !/^[\u0600-\u06FF0-9\s]*$/.test(nameAr)) {
  newErrors.nameAr = `${t("Arabic name must only contain Arabic letters and numbers.")}`;
}
if (descriptionEn.trim() && !/^[a-zA-Z0-9\s]*$/.test(descriptionEn)) {
  newErrors.descriptionEn = `${t("English description must only contain English letters and numbers.")}`;
}
if (descriptionAr.trim() && !/^[\u0600-\u06FF0-9\s]*$/.test(descriptionAr)) {
  newErrors.descriptionAr = `${t("Arabic description must only contain Arabic letters and numbers.")}`;
}

// Price validation
  if (!price && price !== 0 && price !== "0") {
    newErrors.price = `${t("Price is required.")}`;
  } else if (!/^\d+(\.\d{0,2})?$/.test(price)) {
    newErrors.price = `${t("Please enter a valid price (e.g., 5.99).")}`;
  } else if (Number(price) < 0) {
    newErrors.price = `${t("Price must be at least 0 SAR.")}`;
  }

  // Calories validation removed - field is optional

  setState((prev) => ({
    ...prev,
    errors: newErrors,
  }));

  // Check both new errors and existing errors
  if (Object.keys(newErrors).length > 0 || Object.values(state.errors).some(error => error)) {
    return;
  }

  try {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
      return;
    }

    setState((prev) => ({
      ...prev,
      loading: true,
      errors: {}, // Clear previous errors before submission
    }));

    await api.post(
      `/products/${id}/modifiers/${state.currentModifier.id}/options`,
      state.newOption,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    setState((prev) => ({
      ...prev,
      showOptionModal: false,
      loading: false,
      successMessage: `${t("Option added successfully!")}`,
    }));

    await fetchProduct();

    setTimeout(() => {
      setState((prev) => ({ ...prev, successMessage: null }));
    }, 3000);
  } catch (error) {
    toast.error(error.response?.data?.error || `${t("Failed to add option")}`);
    setState((prev) => ({
      ...prev,
      errors: {
        general: error.response?.data?.error || `${t("Failed to add option")}`,
      },
      loading: false,
    }));
  }
};


  const handleEditOptionClick = (modifier, option) => {
    setState((prev) => ({
      ...prev,
      currentModifier: modifier,
      editingOption: option,
      showEditOptionModal: true,
      editOption: {
        nameEn: option.nameEn || "",
        nameAr: option.nameAr || "",
        descriptionEn: option.descriptionEn || "",
        descriptionAr: option.descriptionAr || "",
        price: (option.price !== undefined && option.price !== null) ? option.price : "",
        calories: (option.calories !== undefined && option.calories !== null) ? option.calories : "",
      },
    }));
  };

const handleEditOptionInputChange = (e) => {
  const { name, value } = e.target;
  let newValue = value;
  let updatedErrors = { ...state.errors };

  if (name === "nameEn") {
    if (!value.trim()) {
      updatedErrors.nameEn = t("English name is required.");
    } else if (!/^[a-zA-Z0-9\s]*$/.test(value)) {
      updatedErrors.nameEn = t("English name must only contain English letters and numbers.");
    } else {
      delete updatedErrors.nameEn;
    }
  }

  if (name === "nameAr") {
    if (!value.trim()) {
      updatedErrors.nameAr = t("Arabic name is required.");
    } else if (!/^[\u0600-\u06FF0-9\s]*$/.test(value)) {
      updatedErrors.nameAr = t("Arabic name must only contain Arabic letters and numbers.");
    } else {
      delete updatedErrors.nameAr;
    }
  }

  if (name === "descriptionEn") {
    if (!value.trim()) {
      updatedErrors.descriptionEn = t("English description is required.");
    } else if (!/^[a-zA-Z0-9\s]*$/.test(value)) {
      updatedErrors.descriptionEn = t("English description must only contain English letters and numbers.");
    } else {
      delete updatedErrors.descriptionEn;
    }
  }

  if (name === "descriptionAr") {
    if (!value.trim()) {
      updatedErrors.descriptionAr = t("Arabic description is required.");
    } else if (!/^[\u0600-\u06FF0-9\s]*$/.test(value)) {
      updatedErrors.descriptionAr = t("Arabic description must only contain Arabic letters and numbers.");
    } else {
      delete updatedErrors.descriptionAr;
    }
  }

  if (name === "price") {
    // Limit to 2 decimal places
    if (newValue.includes('.')) {
      const parts = newValue.split('.');
      if (parts[1] && parts[1].length > 2) {
        newValue = parts[0] + '.' + parts[1].substring(0, 2);
      }
    }
    
    if (newValue === "") {
      updatedErrors.price = t("Price is required.");
    } else if (!/^\d+(\.\d{0,2})?$/.test(newValue)) {
      updatedErrors.price = t("Please enter a valid price (e.g., 5.99).");
    } else if (Number(newValue) < 0) {
      updatedErrors.price = t("Price must be at least 0 SAR.");
    } else {
      delete updatedErrors.price;
    }
  }

  if (name === "calories") {
    if (newValue === "") {
      // No validation error for empty calories
      delete updatedErrors.calories;
    } else if (/^\d+$/.test(newValue) && !isNaN(newValue) && Number(newValue) >= 0) {
      delete updatedErrors.calories;
    } else {
      updatedErrors.calories = t("Calories must be a valid integer.");
    }
  }

  setState((prev) => ({
    ...prev,
    editOption: {
      ...prev.editOption,
      [name]: newValue,
    },
    errors: updatedErrors,
  }));
};




  // Edit Option: prevent only spaces and trim on blur
  const handleEditOptionNameBlur = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({
      ...prev,
      editOption: {
        ...prev.editOption,
        [name]: value.trim(),
      },
    }));
  };

const handleEditOptionSubmit = async () => {
  const errors = {};
  const { nameEn, nameAr, descriptionEn, descriptionAr, price, calories } = state.editOption;

  if (!nameEn.trim()) errors.nameEn = `${t("English name is required.")}`;
  if (!nameAr.trim()) errors.nameAr = `${t("Arabic name is required.")}`;
  if (!descriptionEn.trim()) errors.descriptionEn = `${t("English description is required.")}`;
  if (!descriptionAr.trim()) errors.descriptionAr = `${t("Arabic description is required.")}`;

  // Additional character validation
  if (nameEn.trim() && !/^[a-zA-Z0-9\s]*$/.test(nameEn)) {
    errors.nameEn = `${t("English name must only contain English letters and numbers.")}`;
  }
  if (nameAr.trim() && !/^[\u0600-\u06FF0-9\s]*$/.test(nameAr)) {
    errors.nameAr = `${t("Arabic name must only contain Arabic letters and numbers.")}`;
  }
  if (descriptionEn.trim() && !/^[a-zA-Z0-9\s]*$/.test(descriptionEn)) {
    errors.descriptionEn = `${t("English description must only contain English letters and numbers.")}`;
  }
  if (descriptionAr.trim() && !/^[\u0600-\u06FF0-9\s]*$/.test(descriptionAr)) {
    errors.descriptionAr = `${t("Arabic description must only contain Arabic letters and numbers.")}`;
  }

  // Price validation
  if (!price && price !== 0 && price !== "0") {
    errors.price = `${t("Price is required.")}`;
  } else if (!/^\d+(\.\d{0,2})?$/.test(price)) {
    errors.price = `${t("Please enter a valid price (e.g., 5.99).")}`;
  } else if (Number(price) < 0) {
    errors.price = `${t("Price must be at least 0 SAR.")}`;
  }

  // Calories validation removed - field is optional

  setState((prev) => ({ ...prev, errors }));

  // Check both new errors and existing errors
  if (Object.keys(errors).length > 0 || Object.values(state.errors).some(error => error)) {
    return;
  }

  try {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
      return;
    }

    setState((prev) => ({ ...prev, loading: true }));

    await api.put(
      `/products/${id}/modifiers/${state.currentModifier.id}/options/${state.editingOption.id}`,
      state.editOption,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    setState((prev) => ({
      ...prev,
      showEditOptionModal: false,
      loading: false,
      successMessage: `${t("Option updated successfully!")}`,
      errors: {},
    }));

    await fetchProduct();

    setTimeout(() => {
      setState((prev) => ({ ...prev, successMessage: null }));
    }, 3000);
  } catch (error) {
  
    toast.error(error.response?.data?.error || `${t("Failed to update option")}`, { autoClose: 3000 });
    setState((prev) => ({
      ...prev,
      errors: {
        general: error.response?.data?.error || `${t("Failed to add option")}`,
      },
      loading: false,
    }));
  }
};


  const handleDeleteOption = async (modifier, option) => {
    // if (
    //   !window.confirm(
    //     `${t("Are you sure you want to delete the option?")} "${option.nameEn}" ${t("This action cannot be undone.")}`
    //   )
    // ) {
    //   return;
    // }

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/login");
        return;
      }

      setState((prev) => ({ ...prev, loading: true }));

      await api.delete(
        `/products/${id}/modifiers/${modifier.id}/options/${option.id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      // Refresh product data first
      await fetchProduct();

      setState((prev) => ({
        ...prev,
        loading: false,
        successMessage: t("Option deleted successfully!"),
      }));

      setTimeout(() => {
        setState((prev) => ({ ...prev, successMessage: null }));
      }, 3000);
    } catch (error) {
      setState((prev) => ({
        ...prev,
        error: error.response?.data?.error || t("Failed to delete option"),
        loading: false,
      }));
    }
  };

  const handleAddModifierClick = () => {
    setFieldErrors({});
    setState((prev) => ({
      ...prev,
      showModifierModal: true,
      newModifier: {
        name: { en: "", ar: "" },
        is_multiple: false,
        is_radio: false,
        max_option: 1,
        min_option: 0,
      },
    }));
  };

  const handleEditModifierClick = (modifier) => {
    setFieldErrors({});
    setState((prev) => ({
      ...prev,
      showEditModifierModal: true,
      editingModifier: modifier,
      editModifier: {
        name: {
          en: modifier.name?.en || "",
          ar: modifier.name?.ar || "",
        },
        is_multiple: modifier.is_multiple || false,
        is_radio: modifier.is_radio || false,
        max_option: modifier.max_option || 1,
        min_option: modifier.min_option || 0,
      },
    }));
  };

  const validateMinMaxFields = (name, value) => {
    const newErrors = { ...fieldErrors };
    
    if (name === 'min_option' || name === 'max_option') {
      const minVal = name === 'min_option' ? (value === '' ? NaN : parseInt(value)) : (state.newModifier.min_option === '' ? NaN : parseInt(state.newModifier.min_option));
      const maxVal = name === 'max_option' ? (value === '' ? NaN : parseInt(value)) : (state.newModifier.max_option === '' ? NaN : parseInt(state.newModifier.max_option));
      
      // Clear existing errors for these fields to avoid showing stale errors
      delete newErrors.min_option;
      delete newErrors.max_option;
      
      // Only validate if we have values to validate
      if (name === 'min_option' || (name !== 'min_option' && !isNaN(minVal))) {
        if (isNaN(minVal)) {
          newErrors.min_option = t("Minimum is required");
        } else if (minVal < 0) {
          newErrors.min_option = t("Minimum must be at least 0");
        } else if (!isNaN(maxVal) && minVal > maxVal) {
          newErrors.min_option = t("Minimum cannot be greater than maximum");
        }
      }
      
      if (name === 'max_option' || (name !== 'max_option' && !isNaN(maxVal))) {
        if (isNaN(maxVal)) {
          newErrors.max_option = t("Maximum is required");
        } else if (maxVal < 1) {
          newErrors.max_option = t("Maximum must be at least 1");
        } else if (!isNaN(minVal) && maxVal < minVal) {
          newErrors.max_option = t("Maximum must be at least equal to minimum");
        }
      }
      
      // Only update if there are changes to prevent infinite loops
      if (JSON.stringify(newErrors) !== JSON.stringify(fieldErrors)) {
        setFieldErrors(newErrors);
      }
    }
    
    return newErrors;
  };

  const handleModifierInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    let newValue = type === "checkbox" ? checked : value;
    
    // Prevent multiple zeros for number inputs
    if ((name === "min_option" || name === "max_option") && type !== "checkbox") {
      if (/^0+/.test(newValue) && newValue.length > 1) {
        newValue = "0";
      }
    }
    
    // Update the state
    setState(prev => {
      const updatedModifier = {
        ...prev.newModifier,
        [name]: newValue
      };
      
      // Get current values, handling empty strings
      const minVal = name === 'min_option' ? 
        (newValue === '' ? NaN : parseInt(newValue)) : 
        (prev.newModifier.min_option === '' ? NaN : parseInt(prev.newModifier.min_option));
        
      const maxVal = name === 'max_option' ? 
        (newValue === '' ? NaN : parseInt(newValue)) : 
        (prev.newModifier.max_option === '' ? NaN : parseInt(prev.newModifier.max_option));
      
      // Create new errors object
      const newErrors = { ...fieldErrors };
      
      // Clear previous errors for these fields
      delete newErrors.min_option;
      delete newErrors.max_option;
      
      // Validate min
      if (isNaN(minVal)) {
        newErrors.min_option = t("Minimum is required");
      } else if (minVal < 0) {
        newErrors.min_option = t("Minimum must be at least 0");
      } else if (!isNaN(maxVal) && minVal > maxVal) {
        newErrors.min_option = t("Minimum cannot be greater than maximum");
      }
      
      // Validate max
      if (isNaN(maxVal)) {
        newErrors.max_option = t("Maximum is required");
      } else if (maxVal < 1) {
        newErrors.max_option = t("Maximum must be at least 1");
      } else if (!isNaN(minVal) && maxVal < minVal) {
        newErrors.max_option = t("Maximum must be at least equal to minimum");
      }
      
      // Update errors if they've changed
      if (JSON.stringify(newErrors) !== JSON.stringify(fieldErrors)) {
        setFieldErrors(newErrors);
      }
      
      return { ...prev, newModifier: updatedModifier };
    });
  };

  const handleEditModifierInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    let newValue = type === "checkbox" ? checked : value;
    
    // Prevent multiple zeros for number inputs
    if ((name === "min_option" || name === "max_option") && type !== "checkbox") {
      if (/^0+/.test(newValue) && newValue.length > 1) {
        newValue = "0";
      }
    }
    
    // Update the state
    setState(prev => {
      const updatedModifier = {
        ...prev.editModifier,
        [name]: newValue
      };
      
      // Get current values, handling empty strings
      const minVal = name === 'min_option' ? 
        (newValue === '' ? NaN : parseInt(newValue)) : 
        (prev.editModifier.min_option === '' ? NaN : parseInt(prev.editModifier.min_option));
        
      const maxVal = name === 'max_option' ? 
        (newValue === '' ? NaN : parseInt(newValue)) : 
        (prev.editModifier.max_option === '' ? NaN : parseInt(prev.editModifier.max_option));
      
      // Create new errors object
      const newErrors = { ...fieldErrors };
      
      // Clear previous errors for these fields
      delete newErrors.min_option;
      delete newErrors.max_option;
      
      // Validate min
      if (isNaN(minVal)) {
        newErrors.min_option = t("Minimum is required");
      } else if (minVal < 0) {
        newErrors.min_option = t("Minimum must be at least 0");
      } else if (!isNaN(maxVal) && minVal > maxVal) {
        newErrors.min_option = t("Minimum cannot be greater than maximum");
      }
      
      // Validate max
      if (isNaN(maxVal)) {
        newErrors.max_option = t("Maximum is required");
      } else if (maxVal < 1) {
        newErrors.max_option = t("Maximum must be at least 1");
      } else if (!isNaN(minVal) && maxVal < minVal) {
        newErrors.max_option = t("Maximum must be at least equal to minimum");
      }
      
      // Update errors if they've changed
      if (JSON.stringify(newErrors) !== JSON.stringify(fieldErrors)) {
        setFieldErrors(newErrors);
      }
      
      return { ...prev, editModifier: updatedModifier };
    });
  };

  const handleModifierNameChange = (lang, value) => {
    setState((prev) => ({
      ...prev,
      newModifier: {
        ...prev.newModifier,
        name: {
          ...prev.newModifier.name,
          [lang]: value,
        },
      },
    }));

    if(lang === "en"){
      if (!value.trim()) {
        setFieldErrors((prev) => ({
          ...prev,
          nameEn: t("English name is required."),
        }));
      } else if (!/^[a-zA-Z0-9\s]*$/.test(value)) {
        setFieldErrors((prev) => ({
          ...prev,
          nameEn: t("English name must only contain English letters and numbers."),
        }));
      } else {
        setFieldErrors((prev) => {
          const { nameEn, ...rest } = prev;
          return rest;
        });
      }
    }

    if(lang === "ar"){
      if (!value.trim()) {
        setFieldErrors((prev) => ({
          ...prev,
          nameAr: t("Arabic name is required."),
        }));
      } else if (!/^[\u0600-\u06FF0-9\s]*$/.test(value)) {
        setFieldErrors((prev) => ({
          ...prev,
          nameAr: t("Arabic name must only contain Arabic letters and numbers."),
        }));
      } else {
        setFieldErrors((prev) => {
          const { nameAr, ...rest } = prev;
          return rest;
        });
      }
    }
  };

  const handleEditModifierNameChange = (lang, value) => {
    setState((prev) => ({
      ...prev,
      editModifier: {
        ...prev.editModifier,
        name: {
          ...prev.editModifier.name,
          [lang]: value,
        },
      },
    }));

    if(lang === "en"){
      if (!value.trim()) {
        setFieldErrors((prev) => ({
          ...prev,
          nameEn: t("English name is required."),
        }));
      } else if (!/^[a-zA-Z0-9\s]*$/.test(value)) {
        setFieldErrors((prev) => ({
          ...prev,
          nameEn: t("English name must only contain English letters and numbers."),
        }));
      } else {
        setFieldErrors((prev) => {
          const { nameEn, ...rest } = prev;
          return rest;
        });
      }
    }

    if(lang === "ar"){
      if (!value.trim()) {
        setFieldErrors((prev) => ({
          ...prev,
          nameAr: t("Arabic name is required."),
        }));
      } else if (!/^[\u0600-\u06FF0-9\s]*$/.test(value)) {
        setFieldErrors((prev) => ({
          ...prev,
          nameAr: t("Arabic name must only contain Arabic letters and numbers."),
        }));
      } else {
        setFieldErrors((prev) => {
          const { nameAr, ...rest } = prev;
          return rest;
        });
      }
    }
  };

  const handleAddModifierSubmit = async () => {
    // Validate form before submission
    const newErrors = {};
    
    // Name validations
    if (!state.newModifier.name.en.trim()) {
      newErrors.nameEn = t("English name is required.");
    } else if (!/^[a-zA-Z0-9\s]*$/.test(state.newModifier.name.en)) {
      newErrors.nameEn = t("English name must only contain English letters and numbers.");
    }
    
    if (!state.newModifier.name.ar.trim()) {
      newErrors.nameAr = t("Arabic name is required.");
    } else if (!/^[\u0600-\u06FF0-9\s]*$/.test(state.newModifier.name.ar)) {
      newErrors.nameAr = t("Arabic name must only contain Arabic letters and numbers.");
    }
    
    // Validate min/max options
    const minVal = state.newModifier.min_option === '' ? NaN : parseInt(state.newModifier.min_option);
    const maxVal = state.newModifier.max_option === '' ? NaN : parseInt(state.newModifier.max_option);
    
    // Min validation
    if (isNaN(minVal)) {
      newErrors.min_option = t("Minimum is required");
    } else if (minVal < 0) {
      newErrors.min_option = t("Minimum must be at least 0");
    } else if (!isNaN(maxVal) && minVal > maxVal) {
      newErrors.min_option = t("Minimum cannot be greater than maximum");
    }
    
    // Max validation
    if (isNaN(maxVal)) {
      newErrors.max_option = t("Maximum is required");
    } else if (maxVal < 1) {
      newErrors.max_option = t("Maximum must be at least 1");
    } else if (!isNaN(minVal) && maxVal < minVal) {
      newErrors.max_option = t("Maximum must be at least equal to minimum");
    }
    
    // Merge with existing errors to preserve any that might still be valid
    const mergedErrors = { ...fieldErrors, ...newErrors };
    
    // Only update if there are actual changes to prevent unnecessary re-renders
    if (JSON.stringify(mergedErrors) !== JSON.stringify(fieldErrors)) {
      setFieldErrors(mergedErrors);
    }
    
    // If there are any errors, don't submit
    if (Object.keys(mergedErrors).length > 0) {
      return;
    }
    
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/login");
        return;
      }

      setState((prev) => ({ ...prev, loading: true }));

      // Ensure min_option and max_option are sent as integers
      const modifierPayload = {
        ...state.newModifier,
        min_option: parseInt(state.newModifier.min_option, 10),
        max_option: parseInt(state.newModifier.max_option, 10),
      };
      await api.post(`/products/${id}/modifiers`, modifierPayload, {
        headers: { Authorization: `Bearer ${token}` },
      });


      toast.success(t("Modifier added successfully!"));
      setState((prev) => ({
        ...prev,
        showModifierModal: false,
        loading: false,
        successMessage: t("Modifier added successfully!"),
      }));

      await fetchProduct();

      setTimeout(() => {
        setState((prev) => ({ ...prev, successMessage: null }));
      }, 3000);
    } catch (error) {
      toast.error(error.response?.data?.error || t("Failed to add modifier"));
      setState((prev) => ({
        ...prev,
        error: error.response?.data?.error || t("Failed to add modifier"),
        loading: false,
      }));
    }
  };

  const handleEditModifierSubmit = async () => {
    // Validate form before submission
    const newErrors = {};
    
    // Name validations
    if (!state.editModifier.name.en.trim()) {
      newErrors.nameEn = t("English name is required.");
    } else if (!/^[a-zA-Z0-9\s]*$/.test(state.editModifier.name.en)) {
      newErrors.nameEn = t("English name must only contain English letters and numbers.");
    }
    
    if (!state.editModifier.name.ar.trim()) {
      newErrors.nameAr = t("Arabic name is required.");
    } else if (!/^[\u0600-\u06FF0-9\s]*$/.test(state.editModifier.name.ar)) {
      newErrors.nameAr = t("Arabic name must only contain Arabic letters and numbers.");
    }
    
    // Validate min/max options
    const minVal = state.editModifier.min_option === '' ? NaN : parseInt(state.editModifier.min_option);
    const maxVal = state.editModifier.max_option === '' ? NaN : parseInt(state.editModifier.max_option);
    
    // Min validation
    if (isNaN(minVal)) {
      newErrors.min_option = t("Minimum is required");
    } else if (minVal < 0) {
      newErrors.min_option = t("Minimum must be at least 0");
    } else if (!isNaN(maxVal) && minVal > maxVal) {
      newErrors.min_option = t("Minimum cannot be greater than maximum");
    }
    
    // Max validation
    if (isNaN(maxVal)) {
      newErrors.max_option = t("Maximum is required");
    } else if (maxVal < 1) {
      newErrors.max_option = t("Maximum must be at least 1");
    } else if (!isNaN(minVal) && maxVal < minVal) {
      newErrors.max_option = t("Maximum must be at least equal to minimum");
    }
    
    // If there are validation errors, update the state and return early
    if (Object.keys(newErrors).length > 0) {
      setFieldErrors(newErrors);
      return;
    }
    
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/login");
        return;
      }

      setState(prev => ({ ...prev, loading: true }));

      // Ensure min_option and max_option are sent as integers
      const editModifierPayload = {
        ...state.editModifier,
        min_option: parseInt(state.editModifier.min_option, 10),
        max_option: parseInt(state.editModifier.max_option, 10),
      };
      await api.put(
        `/products/${id}/modifiers/${state.editingModifier.id}`,
        editModifierPayload,
        { headers: { Authorization: `Bearer ${token}` } }
      );


      toast.success(t("modifier updated successfully!"));
      setState(prev => ({
        ...prev,
        showEditModifierModal: false,
        loading: false,
        successMessage: t("modifier updated successfully!"),
        errors: {}
      }));

      await fetchProduct();

      setTimeout(() => {
        setState(prev => ({ ...prev, successMessage: null }));
      }, 3000);
    } catch (error) {
      toast.error(error.response?.data?.error || t("Failed to update modifier"));
      setState(prev => ({
        ...prev,
        error: error.response?.data?.error || t("Failed to update modifier"),
        loading: false,
      }));
    }
  };

  const handleDeleteModifier = async (modifier) => {
    // if (!window.confirm(
    //   `Are you sure you want to delete the modifier "${modifier.name.en}"? This action cannot be undone.`
    // )) {
    //   return;
    // }

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/login");
        return;
      }

      setState(prev => ({ ...prev, loading: true }));

      await api.delete(`/modifiers/${modifier.id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setState(prev => ({
        ...prev,
        loading: false,
        successMessage: t("modifier deleted successfully!"),
      }));

      await fetchProduct();

      setTimeout(() => {
        setState((prev) => ({ ...prev, successMessage: null }));
      }, 3000);
    } catch (error) {
      setState((prev) => ({
        ...prev,
        error: error.response?.data?.message || t("Failed to delete modifier"),
        loading: false,
      }));
    }
  };
const fileInputRef = useRef(null);

// Cancel handler
const handleCancel = () => {
  setPreviewUrl(null);
  setHeroImageFailed(false);
  setSelectedImage(null);
  if (fileInputRef.current) fileInputRef.current.value = ""; // Clear file input
};

const handleImageChange = (event) => {
  const file = event.target.files[0];
  if (!file) return;

  const validTypes = ['image/jpeg', 'image/png'];
  if (!validTypes.includes(file.type)) {
    toast.error(t("Please select a JPG or PNG image."));
    fileInputRef.current.value = "";
    return;
  }

  const maxSizeMB = 5;
  const recommendedSizeMB = 2;
  const fileSizeMB = file.size / (1024 * 1024);
  if (fileSizeMB > maxSizeMB) {
    toast.error(t("Image must be 5MB or less."));
    fileInputRef.current.value = "";
    return;
  } else if (fileSizeMB > recommendedSizeMB) {
    toast.warn(t("Image exceeds 2MB. Prefer Smaller Size Image"));
  }

  const img = new Image();
  img.onload = () => {
    const { width, height } = img;

    if (width < 600 || height < 450) {
      toast.error(t("Image must be at least 600px wide and 450px tall."));
      fileInputRef.current.value = "";
      return;
    }

    

    setSelectedImage(file);
    setPreviewUrl(URL.createObjectURL(file));
  };

  img.onerror = () => {
    toast.error(t("Failed to read the image dimensions."));
    fileInputRef.current.value = "";
  };

  img.src = URL.createObjectURL(file);
};


  const handleUpload = async () => {
    try {
      setIsUploading(true);
      // Your upload logic here...
      if (!selectedImage) {
        alert(t("No image selected."));
        return;
      }

      const formData = new FormData();
      formData.append("image", selectedImage);

      // Replace with your actual upload logic or endpoint
      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/login");
        return;
      }

      await api.post(`/product/${id}/image`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      await fetchProduct();
      // On success:
      setUploadStatus({
        type: "success",
        message: t("Image uploaded successfully!"),
      });
      toast.success(t("Image uploaded successfully!"), { autoClose: 3000 });
       setPreviewUrl(null);
    setSelectedImage(null);
    if (fileInputRef.current) fileInputRef.current.value = ""; 
    } catch (error) {
      setUploadStatus({
        type: "danger",
        message: error.message || t("Failed to upload image"),
      });
      toast.error(t("Failed to upload image."), { autoClose: 3000 });
    } finally {
      setIsUploading(false);
    }
  };

  const handleOpenNutritionModal = () => {
    
    setShowNutritionModal(true);
  };



  const handleAllergenCheckbox = (id) => {
    setNutritionFacts((prev) => {
      const exists = prev.allergen_ids.includes(id);
      return {
        ...prev,
        allergen_ids: exists
          ? prev.allergen_ids.filter((aid) => aid !== id)
          : [...prev.allergen_ids, id],
      };
    });
  };



  const handleOpenEditAvailability = () => {
    let availabilityToEdit =
      state.product.availability &&
      typeof state.product.availability === "object"
        ? JSON.parse(JSON.stringify(state.product.availability))
        : JSON.parse(JSON.stringify(defaultAvailability));
    setEditAvailability(availabilityToEdit);
    setShowEditAvailabilityModal(true);
  };

  const handleAvailabilityChange = (day, field, value, idx = null) => {
    setEditAvailability((prev) => {
      const updated = { ...prev };
      if (field === "is_visible") {
        updated[day].is_visible = value;
      } else if (field === "time") {
        updated[day].times[idx][value.key] = value.val;
      }
      return updated;
    });
  };

 const handleAddTimeRange = (day) => {
  setEditAvailability((prev) => {
    const updated = { ...prev };
    const existingTimes = [...updated[day].times]; // copy array
    existingTimes.push({ start: "00:00", end: "23:59" }); // push new time
    updated[day] = {
      ...updated[day],
      times: existingTimes,
    };
    return updated;
  });
};


 const handleRemoveTimeRange = (day, idx) => {
  setEditAvailability((prev) => {
    const updated = { ...prev };
    const updatedTimes = [...updated[day].times]; // create a copy of the times array
    updatedTimes.splice(idx, 1); // safely remove the item
    updated[day] = {
      ...updated[day],
      times: updatedTimes, // reassign the updated array
    };
    return updated;
  });
};


  const handleSaveAvailability = async () => {
    setAvailabilityLoading(true);
    try {
      const token = localStorage.getItem("token");
      await api.patch(
        `/product/${id}/availability`,
        { availability: editAvailability },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setShowEditAvailabilityModal(false);
      await fetchProduct();
    } catch (error) {
      
      setState((prev) => ({
        ...prev,
        error: resolveProductApiError(
          error,
          t,
          "productApiMsgs.failedToUpdateAvailability"
        ),
      }));
    } finally {
      setAvailabilityLoading(false);
    }
  };

const handleDeleteProduct = async () => {
  try {
    
    const token = localStorage.getItem("token");
    await api.delete(`/products/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    setDeleteError(null);
    setShowProductDeleteModal(false);

    toast.success(t("Product deleted successfully."), {
      onClose: () => navigate("/products"), // redirect when toast ends
      autoClose: 1500, // duration in ms (adjust as needed)
    });
  } catch (error) {
    toast.error(error.response?.data?.message || t("Failed to delete product"));
    setDeleteSuccess(null);
    setShowProductDeleteModal(false);
  }
};


  const handleRemoveFromCatalog = async (catalogId) => {
    if (!catalogId) return;
    try {
      const token = localStorage.getItem("token");
      await api.delete(`/catalog/${catalogId}/product/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success(t("Product removed from catalog successfully."));
      setRemoveCatalogError(null);
      await fetchProduct();
    } catch (error) {
      toast.error(
        error.response?.data?.message || t("Failed to remove product from catalog")
      );
      setRemoveCatalogSuccess(null);
    }
  };

useEffect(()=>{
fetchProduct();
},[])
  if (state.loading && !state.product) {
    return (
      <Container className="mt-5">
        <Row>
          <Col md={4} className="d-flex h-100">
            <Card
              style={{ height: "590px" }}
              className="mb-4 shadow-lg flex-grow-1"
            >
              <div
                style={{ height: "300px", width: "100%", position: "relative" }}
                className="mb-2"
              >
                <Skeleton
                  height={300}
                  width={"100%"}
                  style={{ borderRadius: "0.5rem" }}
                />
              </div>
              <Card.Body className="p-4 d-flex flex-column">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <Skeleton height={32} width={100} />
                  <Skeleton height={28} width={60} />
                </div>
                <div className="mt-auto">
                  <div className="bg-light p-3 rounded">
                    <Skeleton
                      height={24}
                      width={"100%"}
                      style={{ marginBottom: 8 }}
                    />
                    <Skeleton height={36} width={"100%"} />
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={8}>
            <Skeleton height={48} width={300} style={{ marginBottom: 24 }} />
            <Skeleton count={6} height={32} style={{ marginBottom: 16 }} />
          </Col>
        </Row>
      </Container>
    );
  }

  if (!state.product) {
    return (
      <Container className="text-center mt-5">
        <h4>Product not found</h4>
      </Container>
    );
  }

  const { product } = state;

  const permissionTooltipMsg = t("noPermissionToAccessThis");
  const overlayPermTooltip = (suffix) => (
    <Tooltip id={`${permTipId}-${suffix}`}>{permissionTooltipMsg}</Tooltip>
  );
  /** Disabled + Bootstrap tooltip when `allowed` is false (RBAC); otherwise normal Button. */
  const bsPermButton = ({
    suffix,
    allowed,
    variant = "outline-primary",
    size = "sm",
    className,
    wrapClassName = "d-inline-block",
    style,
    onClick,
    disabledExtra,
    children,
  }) => {
    if (!allowed) {
      return (
        <OverlayTrigger placement="top" overlay={overlayPermTooltip(suffix)}>
          <span className={wrapClassName}>
            <Button
              variant={variant}
              size={size}
              className={className}
              disabled
              style={{ ...(style || {}), pointerEvents: "none" }}
              type="button"
            >
              {children}
            </Button>
          </span>
        </OverlayTrigger>
      );
    }
    return (
      <Button
        variant={variant}
        size={size}
        className={className}
        style={style}
        onClick={onClick}
        disabled={!!disabledExtra}
        type="button"
      >
        {children}
      </Button>
    );
  };

  const handleCatalogClick = (catalogId) => {
    navigate(`/catalog/${catalogId}`);
  };

  const associatedCatalogColumns = [
    {
      id: "catalogName",
      header: t("catalogname"),
      nowrap: true,
      render: (cat) => (
        <span
          className="product-associated-catalogs__name"
          onClick={() => handleCatalogClick(cat.catalogId)}
        >
          {cat.catalogName}
        </span>
      ),
    },
    {
      id: "storeName",
      header: t("storename"),
      nowrap: true,
      render: (cat) => cat.storeName,
    },
    {
      id: "branchName",
      header: t("branchname"),
      nowrap: true,
      render: (cat) => cat.branchName,
    },
    {
      id: "catalogDate",
      header: t("catalogdate"),
      nowrap: true,
      render: (cat) =>
        cat.catalogDate
          ? formatLocalizedDateTime(cat.catalogDate, dateLocale, {
              withSeconds: true,
            })
          : "",
    },
    {
      id: "actions",
      header: t("actions"),
      nowrap: true,
      className: "oh-table-td--actions",
      headerClassName: "oh-table-th--actions",
      render: (cat) => (
        <div className="oh-table-actions">
          <ActionButton
            variant="delete"
            disabled={!canMutateCatalogLink}
            title={!canMutateCatalogLink ? permissionTooltipMsg : undefined}
            onClick={() => {
              setSelectedCatalogId(cat.catalogId);
              setShowDeleteModal(true);
            }}
          >
            {t("removefromcatalog")}
          </ActionButton>
        </div>
      ),
    },
  ];

  const hasCatalogBlockDel =
    Array.isArray(product.catalogs) && product.catalogs.length > 0;

  return (
    <MDBContainer fluid className="p-4 content-area flex-grow-1">
      {/* {state.error && <Alert variant="danger">{state.error}</Alert>} */}
      {state.successMessage && (
        <Alert variant="success">{state.successMessage}</Alert>
      )}
      {deleteSuccess && <Alert variant="success">{deleteSuccess}</Alert>}
      {deleteError && <Alert variant="danger">{deleteError}</Alert>}
      {removeCatalogSuccess && (
        <Alert variant="success">{removeCatalogSuccess}</Alert>
      )}
      {removeCatalogError && (
        <Alert variant="danger">{removeCatalogError}</Alert>
      )}

      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2><LocalizedReadOnlyText {...localizedNameDisplay(product.name)} /></h2>

        {(() => {
          const deleteBlocked = !canDeleteProduct || hasCatalogBlockDel;
          const deleteTipText = !canDeleteProduct
            ? permissionTooltipMsg
            : hasCatalogBlockDel
              ? t("Delete is disabled because it is linked to a catalog.")
              : "";
          if (deleteBlocked && deleteTipText) {
            return (
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id={`${permTipId}-delete-product`}>{deleteTipText}</Tooltip>
                }
              >
                <span className="d-inline-block">
                  <Button
                    variant="danger"
                    className="ms-2"
                    disabled
                    style={{ pointerEvents: "none" }}
                    type="button"
                  >
                    {t("Delete Product")}
                  </Button>
                </span>
              </OverlayTrigger>
            );
          }
          return (
            <Button
              variant="danger"
              className="ms-2"
              onClick={() => setShowProductDeleteModal(true)}
              type="button"
            >
              {t("Delete Product")}
            </Button>
          );
        })()}

        <DeleteModal
          text={t("areyousureyouwanttodeletethisproduct")}
          showModal={Boolean(
            showProductDeleteModal &&
              canDeleteProduct &&
              !hasCatalogBlockDel
          )}
          confirmDelete={handleDeleteProduct}
          onClose={() => setShowProductDeleteModal(false)}
        />
      </div>

      <Row className="d-flex mb-4 gy-4 align-items-start">
        <Col md={4} className="d-flex">
          <Card className="product-image-card mb-0 w-100">
            <div className="product-image-card__hero">
              {(() => {
                const heroImageSrc = previewUrl
                  ? previewUrl
                  : product.image_path
                    ? product.image_path.startsWith("http")
                      ? product.image_path
                      : getImageUrl(product.image_path)
                    : null;

                if (heroImageSrc && !heroImageFailed) {
                  return (
                    <img
                      src={heroImageSrc}
                      alt={localizedNameText(product.name)}
                      onError={() => setHeroImageFailed(true)}
                    />
                  );
                }

                return (
                  <div className="product-image-card__hero-placeholder">
                    <span className="product-image-card__hero-placeholder-icon">
                      <ImageIcon size={24} aria-hidden="true" />
                    </span>
                    <span>{t("clicktouploadimage")}</span>
                  </div>
                );
              })()}
            </div>
            <div className="product-image-card__pricing">
              <ProductAppPricePanel
                product={product}
                deliveryApps={deliveryApps}
              />
            </div>
            <div className="product-image-card__sidebar-body">
              <div className="product-image-card__upload-card">
                <div className="product-image-card__upload-title">
                  {t("updateproductimage")}
                </div>
                <div className="product-image-card__upload-picker">
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept="image/png,image/jpeg,image/jpg"
                    onChange={handleImageChange}
                    disabled={!canEditProduct || isUploading}
                    className="product-image-card__file-input"
                    tabIndex={-1}
                    aria-hidden="true"
                  />
                  <div
                    className={[
                      "product-image-card__upload-field",
                      !canEditProduct || isUploading
                        ? "product-image-card__upload-field--disabled"
                        : "",
                    ]
                      .filter(Boolean)
                      .join(" ")}
                    onClick={() => {
                      if (canEditProduct && !isUploading) {
                        fileInputRef.current?.click();
                      }
                    }}
                    onKeyDown={(e) => {
                      if (
                        (e.key === "Enter" || e.key === " ") &&
                        canEditProduct &&
                        !isUploading
                      ) {
                        e.preventDefault();
                        fileInputRef.current?.click();
                      }
                    }}
                    role="button"
                    tabIndex={canEditProduct && !isUploading ? 0 : -1}
                    aria-label={t("clicktouploadimage")}
                  >
                    <span className="product-image-card__upload-file-button">
                      {t("chooseFile")}
                    </span>
                    <span className="product-image-card__upload-file-name">
                      {selectedImage
                        ? selectedImage.name
                        : t("nofilechosen")}
                    </span>
                  </div>
                </div>
                <div className="product-image-card__upload-actions">
                  {!canEditProduct ? (
                    <OverlayTrigger
                      placement="top"
                      overlay={overlayPermTooltip("prod-img-upload")}
                    >
                      <span className="d-block w-100">
                        <Button
                          variant="primary"
                          size="sm"
                          disabled
                          style={{ pointerEvents: "none", width: "100%" }}
                          type="button"
                          className="product-image-card__upload-btn"
                        >
                          {t("selectimagefirst")}
                        </Button>
                      </span>
                    </OverlayTrigger>
                  ) : (
                    <Button
                      variant="primary"
                      onClick={handleUpload}
                      disabled={!previewUrl || isUploading}
                      size="sm"
                      type="button"
                      className="product-image-card__upload-btn"
                    >
                      {isUploading ? (
                        <>
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            className="me-2"
                          />
                          {t("uploading")}
                        </>
                      ) : previewUrl ? (
                        t("uploadnewimage")
                      ) : (
                        t("selectimagefirst")
                      )}
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </Card>
        </Col>

        <Col md={8} className="d-flex ">
         <Card style={{ height: "100%" }} className="mb-4 flex-grow-1">
  <Card.Body>
    <div className="d-flex justify-content-between align-items-start ">
      <div>
        <Card.Title className="mb-1">{t("productdetails")}</Card.Title>
        <div className="mb-2">
          <strong>{t("name")}:</strong> <LocalizedReadOnlyText {...localizedNameDisplay(product.name)} />
        </div>
       
      </div>
      {bsPermButton({
        suffix: "product-details-edit",
        allowed: canEditProduct,
        variant: "outline-primary",
        onClick: () => setShowProductModal(true),
        children: t("edit"),
      })}
    </div>

    <Card.Text className="mb-4">
      <div className="mb-2">
        <strong>{t("description", "Description")}:</strong>{" "}
        <LocalizedReadOnlyText {...localizedNameDisplay(product.description, "description")} />
      </div>
      <div className="mt-3">
        {bsPermButton({
          suffix: "product-nutrition",
          allowed: canEditProduct,
          variant: "outline-info",
          onClick: handleOpenNutritionModal,
          children: t("managenutritionfacts"),
        })}
      </div>
    </Card.Text>

    {/* Nutritional Facts Section */}
    {product.nutrition_facts && (
      <div className="mb-3 p-3 bg-light rounded border">
        <div className="fw-bold mb-2"> {t("nutritionfacts")}</div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(110px, 1fr))",
            gap: "8px",
            overflowY: "auto",
          }}
        >
          {nutritionFields.map((field) => {
            const rawValue = product.nutrition_facts[field.name];
            const isValueAvailable =
              rawValue !== null &&
              rawValue !== undefined &&
              rawValue !== "" &&
              !Number.isNaN(rawValue);

            const valueText = isValueAvailable
              ? `${rawValue}${field.unit ? ` ${field.unit}` : ""}`
              : t("N/A");

            return (
              <div
                key={field.name}
                style={{
                  backgroundColor: "#fff",
                  border: "1px solid #6c757d",
                  padding: "8px",
                  borderRadius: "6px",
                  textAlign: "center",
                  fontSize: "13px",
                  fontWeight: 500,
                }}
              >
                <div style={{ fontSize: "11px", color: "#6c757d" }}>
                  {t(field.displayName)}
                </div>
                <div>{valueText}</div>
              </div>
            );
          })}
        </div>

        <hr className="my-3" />

        <div style={{ fontSize: "14px" }}>
          <strong style={{ fontSize: "15px" }}> {t("allergens")}:</strong>{" "}
          {Array.isArray(product.nutrition_facts.allergen_ids) &&
          product.nutrition_facts.allergen_ids.length > 0
            ? product.nutrition_facts.allergen_ids
                .map((aid) => {
                  const allergen = allergens.find(
                    (a) => a.external_id === aid
                  );
                  return allergen
                    ? localizedAllergenLabel(allergen)
                    : aid;
                })
                .join(", ")
            : `${t("None")}`}
        </div>
      </div>
    )}

    <ListGroup variant="flush">
      <ListGroup.Item>
        <strong>{t("Store")}:</strong> {product.storeName || product.store?.name || product.category_id?.storeName || product.category_id?.store?.name || t("N/A")}
      </ListGroup.Item>
      <ListGroup.Item>
        <strong> {t("category")}:</strong>{" "}
        <LocalizedReadOnlyText {...localizedNameDisplay(product.category_id?.name)} />
      </ListGroup.Item>
      <ListGroup.Item>
        <strong>{t("status")}:</strong>{" "}
        {product.is_visible ? (
          <Badge bg="success">{t("Available")}</Badge>
        ) : (
          <Badge bg="danger">{t("Not Available")}</Badge>
        )}
      </ListGroup.Item>
    </ListGroup>
  </Card.Body>
</Card>

        </Col>
      </Row>
<UpdateProductModal
  show={Boolean(showProductModal && canEditProduct)}
  productDetails={product}
  onClose={() => setShowProductModal(false)}
  fetchProduct={fetchProduct}
/>
      {/* Modifiers Section */}
      <Row className="mb-4">
        <Col>
          <Card className="shadow-lg border-0 rounded-3 overflow-hidden">
            <Card.Header className="bg-gradient-primary text-white p-3 p-md-4">
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
                <div className="d-flex align-items-center gap-2 flex-wrap">
                  <h5 className="mb-0 text-dark fw-bold">
                     {t("customizationoptions")}
                  </h5>
                  {product.modifiers?.length > 0 && (
                    <Badge
                      bg="light"
                      text="dark"
                      className="px-2 py-1 rounded-pill fs-6"
                    >
                      {product.modifiers.length}
                    </Badge>
                  )}
                </div>
                {bsPermButton({
                  suffix: "add-modifier-head",
                  allowed: canEditProduct,
                  variant: "light",
                  className:
                    "d-flex align-items-center gap-2 px-3 py-2 rounded-pill shadow-sm",
                  onClick: handleAddModifierClick,
                  children: (
                    <>
                      <i className="fas fa-plus"></i>
                      <span className="d-none d-sm-inline">{t("addmodifier")}</span>
                      <span className="d-inline d-sm-none">{t("add")}</span>
                    </>
                  ),
                })}
              </div>
            </Card.Header>

            <Card.Body className="p-3 p-md-4">
              {product.modifiers?.length > 0 ? (
                <div className="row g-3">
                  {product.modifiers.map((modifier) => (
                    <div key={modifier.id} className="col-12">
                      <div className="card border-0 shadow-sm bg-light rounded-3">
                        <div className="card-body p-2 p-md-4">
                          {/* Modifier Header */}
                          <div className="d-flex flex-column flex-lg-row justify-content-between align-items-start gap-3 mb-3">
                            <div className="flex-grow-1">
                             <h6
  className="mb-1 fw-bold text-dark"
  style={{ maxWidth: "300px", wordWrap: "break-word", whiteSpace: "normal" }}
>
  <LocalizedReadOnlyText {...localizedNameDisplay(modifier.name)} />
</h6>

                              <Badge
                                bg={modifier.is_radio ? "info" : "success"}
                                className="rounded-pill"
                              >
                                {modifier.is_radio
                                  ? `${t("Select one")}`
                                  : `${t("Select up to")} ${modifier.max_option}`}
                              </Badge>
                            </div>

                            {/* Action Buttons */}
                   {canEditProduct ? (
                   <div className="modifier-action-buttons d-flex gap-2 align-self-start overflow-auto flex-nowrap">
  <Button
    variant="outline-success"
    size="sm"
    className="rounded px-3 text-nowrap"
    onClick={() => handleAddOptionClick(modifier)}
    type="button"
  >
    <i className="fas fa-plus me-1"></i>
    <span className="d-none d-md-inline">{t("addoption")}</span>
    <span className="d-inline d-md-none">{t("add")}</span>
  </Button>

  <Button
    variant="outline-primary"
    size="sm"
    className="rounded px-3 text-nowrap"
    onClick={() => handleEditModifierClick(modifier)}
    type="button"
  >
    <i className="fas fa-edit me-1"></i>
    <span className="d-none d-md-inline">{t("edit")}</span>
    <span className="d-inline d-md-none">{t("edit")}</span>
  </Button>

  <Button
    variant="outline-danger"
    size="sm"
    className="rounded px-3 text-nowrap"
    onClick={() => setDeleteModifierTarget(modifier)}
    type="button"
  >
    <i className="fas fa-trash me-1"></i>
    <span className="d-none d-md-inline">{t("delete")}</span>
    <span className="d-inline d-md-none">{t("delete")}</span>
  </Button>
  {deleteModifierTarget && canEditProduct && (
  <DeleteModal
    text={`Are you sure you want to delete the modifier "${localizedNameText(deleteModifierTarget.name)}"? This action cannot be undone.`}
    showModal={Boolean(deleteModifierTarget && canEditProduct)}
    confirmDelete={() => {
      console.log("hello", modifier)
      handleDeleteModifier(deleteModifierTarget);
      setDeleteModifierTarget(null);
    }}
    onClose={() => setDeleteModifierTarget(null)}
  />
)}
</div>
                   ) : (
                     <OverlayTrigger
                       placement="top"
                       overlay={overlayPermTooltip(`mod-act-${modifier.id}`)}
                     >
                       <span className="d-inline-block align-self-start">
                         <div
                           className="modifier-action-buttons d-flex gap-2 overflow-auto flex-nowrap"
                           style={{
                             pointerEvents: "none",
                             opacity: 0.72,
                             cursor: "not-allowed",
                           }}
                         >
                           <Button
                             variant="outline-success"
                             size="sm"
                             className="rounded px-3 text-nowrap"
                             disabled
                             type="button"
                           >
                             <i className="fas fa-plus me-1"></i>
                             <span className="d-none d-md-inline">{t("addoption")}</span>
                             <span className="d-inline d-md-none">{t("add")}</span>
                           </Button>
                           <Button
                             variant="outline-primary"
                             size="sm"
                             className="rounded px-3 text-nowrap"
                             disabled
                             type="button"
                           >
                             <i className="fas fa-edit me-1"></i>
                             <span className="d-none d-md-inline">{t("edit")}</span>
                             <span className="d-inline d-md-none">{t("edit")}</span>
                           </Button>
                           <Button
                             variant="outline-danger"
                             size="sm"
                             className="rounded px-3 text-nowrap"
                             disabled
                             type="button"
                           >
                             <i className="fas fa-trash me-1"></i>
                             <span className="d-none d-md-inline">{t("delete")}</span>
                             <span className="d-inline d-md-none">{t("delete")}</span>
                           </Button>
                         </div>
                       </span>
                     </OverlayTrigger>
                   )}


                          </div>

                          {/* Options */}
                   {modifier.options.length > 0 ? (
 <div className="modifier-card-grid">
  {modifier.options.map((option) => (
    <div
      key={option.id}
      className="card modifier-card border-0 bg-white shadow-sm rounded-3 h-auto d-flex flex-column"
    >
      <div className="card-body p-3 d-flex flex-column flex-grow-1">
        <div className="d-flex align-items-start gap-3">
          <Form.Check
            type={modifier.is_radio ? "radio" : "checkbox"}
            id={`${modifier.id}-${option.id}`}
            name={modifier.id}
            className="mb-0 mt-1"
            value={option.id}
            onChange={(e) =>
              handleModifierChange(modifier.id, option.id, e.target.checked)
            }
            checked={state.selectedModifiers[modifier.id]?.includes(option.id)}
            disabled={
              !canEditProduct ||
              (!modifier.is_radio &&
                state.selectedModifiers[modifier.id]?.length >= modifier.max_option &&
                !state.selectedModifiers[modifier.id]?.includes(option.id))
            }
          />

          <div className="flex-grow-1">
            <div className="d-flex flex-column gap-2">
              <h6 className="mb-0 fw-semibold text-dark" style={{ wordBreak: 'break-word' }}>
                <LocalizedReadOnlyText {...localizedOptionDisplay(option)} />
              </h6>

              <p className="mb-0 description-text-size text-secondary" style={{ wordBreak: 'break-word' }}>
                <LocalizedReadOnlyText {...localizedOptionDescriptionDisplay(option)} />
              </p>

              <div className="d-flex flex-wrap gap-2 align-items-center">
                <span className="text-primary fw-bold">
                  <PriceDisplay value={option.price} />
                </span>
                <Badge bg="secondary" className="rounded-pill">
                  +{option.calories} {t("kcal")}
                </Badge>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-auto pt-3 d-flex justify-content-between gap-2">
          {bsPermButton({
            suffix: `opt-e-${modifier.id}-${option.id}`,
            allowed: canEditProduct,
            variant: "outline-primary",
            size: "sm",
            wrapClassName: "flex-grow-1 d-flex",
            className:
              "w-100 d-flex align-items-center justify-content-center gap-1",
            onClick: () => handleEditOptionClick(modifier, option),
            children: (
              <>
                <i className="fas fa-edit"></i> <span>{t("edit")}</span>
              </>
            ),
          })}
          {bsPermButton({
            suffix: `opt-d-${modifier.id}-${option.id}`,
            allowed: canEditProduct,
            variant: "outline-danger",
            size: "sm",
            wrapClassName: "flex-grow-1 d-flex",
            className:
              "w-100 d-flex align-items-center justify-content-center gap-1",
            onClick: () => setDeleteTarget({ modifier, option }),
            children: (
              <>
                <i className="fas fa-trash"></i> <span>{t("delete")}</span>
              </>
            ),
          })}
         {deleteTarget && canEditProduct && (
  <DeleteModal
    text={`${t("Are you sure you want to delete the option?")} "${localizedOptionDisplay(deleteTarget.option).text}" ${t("This action cannot be undone.")}`}
    showModal={!!deleteTarget}
    confirmDelete={() => {
      handleDeleteOption(deleteTarget.modifier, deleteTarget.option);
      setDeleteTarget(null);
    }}
    onClose={() => setDeleteTarget(null)}
  />
)}
        </div>
      </div>
    </div>
  ))}

  <style>{`
    .modifier-card-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
      gap: 16px;
      width: 100%;
      max-width: 1200px;
      margin: 0 auto;
    }

    .modifier-card {
      width: 100%;
    }

    .modifier-card h6,
    .modifier-card p {
      word-break: break-word;
    }
  `}</style>
</div>


)  : (
                            <Alert
                              variant="info"
                              className="mb-0 rounded-3 border-0"
                            >
                              <div className="d-flex align-items-center gap-2">
                                <i className="fas fa-info-circle"></i>
                                <span>
                                  {t("No options available for this modifier")}
                                </span>
                              </div>
                            </Alert>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <Alert
                  variant="secondary"
                  className="mb-0 text-center py-4 rounded-3 border-0"
                >
                  <div className="d-flex flex-column align-items-center gap-2">
                    <i className="fas fa-cog fa-2x text-muted"></i>
                    <h6 className="mb-0">
                     {t("No modifiers available for this product")}
                    </h6>
                    <p className="text-muted small mb-0">
                      {t("Add your first modifier to get started")}
                    </p>
                  </div>
                </Alert>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="px-2">
      <Card className="p-4 rounded-4 w-100 border-0 modern-card">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h4 className="mb-0">{t("Product Availability Status")}</h4>
         
        </div>
        
        <Card.Body className="p-0">
          <Row className="g-4">
            <Col xs={12} md={6}>
              <div className="p-3 rounded-4 h-100 border-0 platform-section supported-section">
                <div className="d-flex align-items-center gap-2 mb-3">
                  <div className="icon-wrapper bg-success p-2 rounded-circle d-flex align-items-center justify-content-center">
                    <Check className="text-white" size={14} />
                  </div>
                  <h5 className="mb-0 fw-semibold text-success">{t("Supported Platforms")}</h5>
                </div>
               
                <div className="platform-grid">
                  {supportedPlatforms.map(platform => {
                    const logo = resolvePlatformLogo(platform);
                    return (
                    <div key={platform.id} className="platform-item">
                      <div className="platform-content">
                        <div className="platform-logo-wrapper p-1 rounded-circle mb-2">
                          <img
                            src={logo?.src}
                            alt={isArabic && platform.nameAr ? platform.nameAr : platform.name}
                            width={24}
                            height={24}
                            className="img-fluid"
                            onError={(event) => handlePlatformLogoError(event, platform)}
                          />
                        </div>
                        <span className="platform-name">{isArabic && platform.nameAr ? platform.nameAr : platform.name}</span>
                        <div className="status-badge supported">{t("Supported")}</div>
                      </div>
                    </div>
                    );
                  })}
                </div>
              </div>
            </Col>

            <Col xs={12} md={6}>
              <div className="p-3 rounded-4 h-100 border-0 platform-section unsupported-section">
                <div className="d-flex align-items-center gap-2 mb-3">
                  <div className="icon-wrapper bg-danger p-2 rounded-circle d-flex align-items-center justify-content-center">
                    <X className="text-white" size={14} />
                  </div>
                  <h5 className="mb-0 fw-semibold text-danger">{t("Unsupported Platforms")}</h5>
                </div>
              
                <div className="platform-grid">
                  {unsupportedPlatforms.map(platform => {
                    const logo = resolvePlatformLogo(platform);
                    return (
                    <div key={platform.id} className="platform-item">
                      <div className="platform-content">
                        <div className="platform-logo-wrapper p-1 rounded-circle mb-2 opacity-50">
                          <img
                            src={logo?.src}
                            alt={isArabic && platform.nameAr ? platform.nameAr : platform.name}
                            width={24}
                            height={24}
                            className="img-fluid grayscale"
                            onError={(event) => handlePlatformLogoError(event, platform)}
                          />
                        </div>
                        <span className="platform-name text-muted">{isArabic && platform.nameAr ? platform.nameAr : platform.name}</span>
                        <div className="status-badge unsupported">{t("Unsupported")}</div>
                      </div>
                    </div>
                    );
                  })}
                </div>
              </div>
            </Col>
          </Row>
        </Card.Body>
        
       
        
        <style jsx>{`
          .modern-card {
            background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%) !important;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08), 0 5px 15px rgba(0, 0, 0, 0.04) !important;
          }
          
          .platform-section {
            background: rgba(255, 255, 255, 0.7) !important;
            backdrop-filter: blur(10px);
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05) !important;
            transition: transform 0.2s ease, box-shadow 0.2s ease;
          }
          
          .platform-section:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1) !important;
          }
          
          .supported-section {
            border-left: 3px solid #198754 !important;
          }
          
          .unsupported-section {
            border-left: 3px solid #dc3545 !important;
          }
          
          .platform-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 8px;
          }
          
          .platform-item {
            display: flex;
          }
          
          .platform-content {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 6px;
            border-radius: 8px;
            background: white;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
            width: 100%;
            transition: all 0.2s ease;
          }
          
          .platform-content:hover {
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
            transform: translateY(-2px);
          }
          
          .platform-name {
            font-size: 0.55rem;
            font-weight: 500;
            text-align: center;
            margin-bottom: 2px;
          }
          
          .status-badge {
            font-size: 0.5rem;
            padding: 2px 4px;
            border-radius: 6px;
            font-weight: 500;
          }
          
          .status-badge.supported {
            background: rgba(25, 135, 84, 0.1);
            color: #198754;
          }
          
          .status-badge.unsupported {
            background: rgba(220, 53, 69, 0.1);
            color: #dc3545;
          }
          
          .icon-wrapper {
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          }
          
          @media (max-width: 768px) {
            .platform-grid {
              grid-template-columns: repeat(2, 1fr);
            }
          }
          
          @media (max-width: 480px) {
            .platform-grid {
              grid-template-columns: 1fr;
            }
          }
        `}</style>
      </Card>
    </Row>

      {/* Availability Section */}
      <Row>
        <Col>
          <Card className="shadow-sm rounded-4">
            <Card.Header className="bg-light d-flex flex-wrap justify-content-between align-items-center px-3 py-2">
              <h5 className="mb-2 mb-md-0">{t("availabilityschedule")}</h5>
              {bsPermButton({
                suffix: "avail-edit-head",
                allowed: canEditProduct,
                variant: "outline-primary",
                size: "sm",
                onClick: handleOpenEditAvailability,
                children: t("edit"),
              })}
            </Card.Header>

           <Card.Body className="p-3">
  {(!product.availability ||
    Object.keys(product.availability).length === 0) ? (
    <div className="text-center text-muted py-3">
      {t("No Schedule Available")}
    </div>
  ) : (
    <ListGroup variant="flush">
      {Object.entries(product.availability).map(([day, details]) => (
        <ListGroup.Item
          key={day}
          className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center py-2"
        >
          <strong className="text-capitalize">{t(day)}</strong>
          <div className="mt-2 mt-md-0 d-flex flex-wrap gap-2 justify-content-md-end">
            {details.is_visible && details.times?.length > 0 ? (
              details.times.map((t, i) => (
                <Badge
                  key={i}
                  bg="primary"
                  className="px-2 py-1"
                  style={{ whiteSpace: "nowrap" }}
                >
                  {t.start} - {t.end}
                </Badge>
              ))
            ) : (
              <Badge bg="danger">{t("close")}</Badge>
            )}
          </div>
        </ListGroup.Item>
      ))}
    </ListGroup>
  )}
</Card.Body>

          </Card>
        </Col>
      </Row>

      {/* Add Modifier Modal */}
      <Modal
        show={Boolean(state.showModifierModal && canEditProduct)}
        onHide={() => {
          setFieldErrors({});
          setState((prev) => ({ ...prev, showModifierModal: false }));
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("addmodifier")}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <FormGroup className="mb-3">
              <FormLabel>{t("nameen")} *</FormLabel>
              <Form.Control
                type="text"
                value={state.newModifier.name.en}
                onChange={(e) => handleModifierNameChange("en", e.target.value)}
                placeholder={t("Extras, Size, etc.")}
                required
              />
              {fieldErrors.nameEn && (
                  <div className="invalid-feedback d-block m-1">
                    {fieldErrors.nameEn}
                  </div>
                )}
            </FormGroup>

            <FormGroup className="mb-3">
              <FormLabel className="mt-3">{t("namear")} *</FormLabel>
              <Form.Control
                type="text"
                value={state.newModifier.name.ar}
                onChange={(e) => handleModifierNameChange("ar", e.target.value)}
                placeholder="إضافات, مقاس, إلخ"
                required
              />
              {fieldErrors.nameAr && (
                  <div className="invalid-feedback d-block m-1">
                    {fieldErrors.nameAr}
                  </div>
                )}
            </FormGroup>

            <Row className="mb-3">
              <Col md={6}>
                <FormGroup>
                  <Form.Check
                    type="checkbox"
                    label={t("multipleselection")}
                    name="is_multiple"
                    checked={state.newModifier.is_multiple}
                    onChange={handleModifierInputChange}
                    className="mt-3"
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Form.Check
                    type="checkbox"
                    label={t("radiobuttonstyle")}
                    name="is_radio"
                    checked={state.newModifier.is_radio}
                    onChange={handleModifierInputChange}
                    className="mt-3"
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <FormGroup className="mb-3">
                  <FormLabel>{t("minimumoptions")}</FormLabel>
                  <Form.Control
                    type="number"
                    name="min_option"
                    value={state.newModifier.min_option}
                    onChange={handleModifierInputChange}
                    min="0"
                    onKeyDown={(e) => {
                      if (['-', '+', 'e', 'E', '.'].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    isInvalid={!!fieldErrors.min_option}
                  />
                  <div style={{ minHeight: '1.5rem', marginTop: '0.25rem' }}>
                    {fieldErrors.min_option && (
                      <div className="text-danger" style={{ fontSize: '0.875rem' }}>
                        {fieldErrors.min_option}
                      </div>
                    )}
                  </div>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup className="mb-3">
                  <FormLabel>{t("maximumoptions")}</FormLabel>
                  <Form.Control
                    type="number"
                    name="max_option"
                    value={state.newModifier.max_option}
                    onChange={handleModifierInputChange}
                    min="1"
                    onKeyDown={(e) => {
                      if (['-', '+', 'e', 'E', '.'].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    isInvalid={!!fieldErrors.max_option}
                  />
                  <div style={{ minHeight: '1.5rem', marginTop: '0.25rem' }}>
                    {fieldErrors.max_option && (
                      <div className="text-danger" style={{ fontSize: '0.875rem' }}>
                        {fieldErrors.max_option}
                      </div>
                    )}
                  </div>
                </FormGroup>
              </Col>
            </Row>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setFieldErrors({});
              setState((prev) => ({ ...prev, showModifierModal: false }));
            }}
          >
            {t("cancel")}
          </Button>

          <Button
            variant="primary"
            onClick={handleAddModifierSubmit}
            disabled={state.loading}
          >
            {state.loading ? (
              <>
                <Spinner as="span" size="sm" animation="border" role="status" />
                <span className="ms-2">Adding...</span>
              </>
            ) : (
             `${t("addmodifier")}`
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Edit Modifier Modal */}
      <Modal
        show={Boolean(state.showEditModifierModal && canEditProduct)}
        onHide={() => {
          setFieldErrors({});
          setState((prev) => ({ ...prev, showEditModifierModal: false }));
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("editmodifier")}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <FormGroup className="mb-3">
              <FormLabel>{t("nameen")} *</FormLabel>
              <Form.Control
                type="text"
                value={state.editModifier.name.en}
                onChange={(e) =>
                  handleEditModifierNameChange("en", e.target.value)
                }
                placeholder="Extras, Size, etc."
                required
              />
              {fieldErrors.nameEn && (
                  <div className="invalid-feedback d-block m-1">
                    {fieldErrors.nameEn}
                  </div>
                )}
            </FormGroup>

            <FormGroup className="mb-3">
              <FormLabel className="mt-3">{t("namear")} *</FormLabel>
              <Form.Control
                type="text"
                value={state.editModifier.name.ar}
                onChange={(e) =>
                  handleEditModifierNameChange("ar", e.target.value)
                }
                placeholder="إضافات, مقاس, إلخ"
                required
              />
              {fieldErrors.nameAr && (
                  <div className="invalid-feedback d-block m-1">
                    {fieldErrors.nameAr}
                  </div>
                )}
            </FormGroup>

            <Row className="mb-3">
              <Col md={6}>
                <FormGroup>
                  <Form.Check
                    type="checkbox"
                    label={t("multipleselection")}
                    name="is_multiple"
                    checked={state.editModifier.is_multiple}
                    onChange={handleEditModifierInputChange}
                    className="mt-3"
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Form.Check
                    type="checkbox"
                    label={t("radiobuttonstyle")}
                    name="is_radio"
                    checked={state.editModifier.is_radio}
                    onChange={handleEditModifierInputChange}
                    className="mt-3"
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <FormGroup className="mb-3">
                  <FormLabel>{t("minimumoptions")}</FormLabel>
                  <Form.Control
                    type="number"
                    name="min_option"
                    value={state.editModifier.min_option}
                    onChange={handleEditModifierInputChange}
                    min="0"
                    onKeyDown={(e) => {
                      if (['-', '+', 'e', 'E', '.'].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                  />
                  <div style={{ minHeight: '1.5rem', marginTop: '0.25rem' }}>
                    {fieldErrors.min_option && (
                      <div className="text-danger" style={{ fontSize: '0.875rem' }}>
                        {fieldErrors.min_option}
                      </div>
                    )}
                  </div>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup className="mb-3">
                  <FormLabel>{t("maximumoptions")}</FormLabel>
                  <Form.Control
                    type="number"
                    name="max_option"
                    value={state.editModifier.max_option}
                    onChange={handleEditModifierInputChange}
                    min="1"
                    onKeyDown={(e) => {
                      if (['-', '+', 'e', 'E', '.'].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                  />
                  <div style={{ minHeight: '1.5rem', marginTop: '0.25rem' }}>
                    {fieldErrors.max_option && (
                      <div className="text-danger" style={{ fontSize: '0.875rem' }}>
                        {fieldErrors.max_option}
                      </div>
                    )}
                  </div>
                </FormGroup>
              </Col>
            </Row>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setFieldErrors({});
              setState((prev) => ({ ...prev, showEditModifierModal: false }));
            }}
          >
            {t("cancel")}
          </Button>

          <Button
            variant="primary"
            onClick={handleEditModifierSubmit}
            disabled={state.loading}
          >
            {state.loading ? (
              <>
                <Spinner as="span" size="sm" animation="border" role="status" />
                <span className="ms-2">Updating...</span>
              </>
            ) : (
             ` ${t("updatemodifier")}`
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Add Option Modal */}
{isOptionModalVisible && canEditProduct && (
  <>
    <div className={`modal-backdrop modal-backdrop-blur ${state.showOptionModal ? 'fade-in' : 'fade-out'}`} />

    <div className={`modal fade-custom ${state.showOptionModal ? 'fade-in' : 'fade-out'}`} tabIndex="-1" role="dialog">
      <div ref={modalRef} className="modal-dialog modal-dialog-centered modal-custom" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Add Option to <LocalizedReadOnlyText {...localizedNameDisplay(state.currentModifier?.name)} /></h5>
            <button
              type="button"
              className="btn-close"
              onClick={() =>
                setState((prev) => ({
                  ...prev,
                  showOptionModal: false,
                  errors: {},
                }))
              }
            />
          </div>

          <div className="scroll-hint text-muted small text-center mt-1 mb-0">⬇ {t("scrolltoupdatemore")}</div>

          <div className="modal-body">
           

            <form>
              {[
                { label: `${t("nameen")} *`, name: 'nameEn', placeholder: `${t("Cheese, Spicy, etc.")}` },
                { label: `${t("namear")} *`, name: 'nameAr', placeholder: `${t("Cheese, Spicy, etc.")}` },
                { label:  `${t("descriptionen")} *`, name: 'descriptionEn', placeholder: `${t("Description in English")}` },
                { label:  `${t("descriptionar")} *`, name: 'descriptionAr', placeholder: `${t("Description in Arabic")}` },
              ].map((field) => (
                <div className="mb-4" key={field.name}>
                  <label className="form-label" style={{ marginBottom: '4px' }}>{field.label}</label>
                  <input
                    type="text"
                    name={field.name}
                    value={state.newOption[field.name]}
                    onChange={handleOptionInputChange}
                    placeholder={field.placeholder}
                    className={`form-control ${state.errors?.[field.name] ? 'is-invalid' : ''}`}
                    required
                    pattern=".*\\S.*"
                    title="Cannot be only spaces"
                    onBlur={handleOptionNameBlur}
                  />
                  <div className="invalid-feedback" style={{ minHeight: '1.5em' }}>
                    {state.errors?.[field.name] || ''}
                  </div>
                </div>
              ))}

              <div className="row">
                <div className="col-md-6 mb-4">
                  <label className="form-label" style={{ marginBottom: '4px' }}>{t("price")} (SAR) *</label>
                  <input
                    type="number"
                    name="price"
                    value={state.newOption.price}
                    onChange={handleOptionInputChange}
                    placeholder={t("price")}
                    className={`form-control ${state.errors?.price ? 'is-invalid' : ''}`}
                    required
                    min="0.01"
                    step="0.01"
                    onBlur={handleOptionNameBlur}
                    onKeyDown={(e) => {
                      if (['e', 'E', '+', '-'].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    style={{
                      MozAppearance: 'textfield'
                    }}
                  />
                  <div className="invalid-feedback" style={{ minHeight: '1.5em' }}>
                    {state.errors?.price || ''}
                  </div>
                </div>

                <div className="col-md-6 mb-4">
                  <label className="form-label" style={{ marginBottom: '4px' }}>{t("calories")}</label>
                  <input
                    type="number"
                    name="calories"
                    value={state.newOption.calories}
                    onChange={handleOptionInputChange}
                    placeholder={t("calories")}
                    className={`form-control ${state.errors?.calories ? 'is-invalid' : ''}`}
                    required
                    min="1"
                    step="1"
                    onBlur={handleOptionNameBlur}
                    onKeyDown={(e) => {
                      if (['e', 'E', '+', '-', '.'].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    style={{
                      MozAppearance: 'textfield'
                    }}
                  />
                  <div className="invalid-feedback" style={{ minHeight: '1.5em' }}>
                    {state.errors?.calories || ''}
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div className="modal-footer">
            <Button
              type="button"
              color="secondary"
              onClick={() =>
                setState((prev) => ({
                  ...prev,
                  showOptionModal: false,
                  errors: {},
                }))
              }
            >
              {t("cancel")}
            </Button>

            <Button
              type="button"
              color="primary"
              onClick={handleAddOptionSubmit}
              disabled={state.loading}
            >
              {state.loading ? (
                <>
                  <span className="spinner-border spinner-border-sm" role="status"></span>
                  <span className="ms-2">Adding...</span>
                </>
              ) : (
               `${t("save")}`
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>

  <style>{`
.modal-custom {
  max-width: 500px;
  width: 100%;
}

.modal-backdrop-blur {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  backdrop-filter: blur(4px);
  background-color: rgba(0, 0, 0, 0.3);
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}

.modal-backdrop-blur.fade-in {
  opacity: 1;
}

.modal-backdrop-blur.fade-out {
  opacity: 0;
}

.modal.fade-custom {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  pointer-events: none;
  padding: 1rem;
}

.modal.fade-custom.fade-in {
  opacity: 1;
  pointer-events: auto;
}

.modal.fade-custom.fade-out {
  opacity: 0;
  pointer-events: none;
}

.modal-content {
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.modal-body {
  overflow-y: auto;
  flex-grow: 1;
  padding-bottom: 2rem;
  position: relative;
}

/* Hide number input arrows */
input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

/* Scrollbar Styling */
.modal-body::-webkit-scrollbar {
  width: 6px;
}

.modal-body::-webkit-scrollbar-thumb {
  background-color: rgba(0,0,0,0.3);
  border-radius: 4px;
}

.modal-body {
  scrollbar-width: thin;
}

/* REMOVE bottom fade */
.modal-body::after {
  content: none !important;
  display: none !important;
}
`}</style>

  </>
)}




      {/* Edit Option Modal */}
{isEditModalVisible && canEditProduct && (
  <>
    <div className={`modal-backdrop modal-backdrop-blur ${state.showEditOptionModal ? "fade-in" : "fade-out"}`} />

    <div className={`modal fade-custom ${state.showEditOptionModal ? "fade-in" : "fade-out"}`} tabIndex="-1" role="dialog">
      <div ref={editModalRef} className="modal-dialog modal-dialog-centered modal-custom" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{t("Edit Option in")} <LocalizedReadOnlyText {...localizedNameDisplay(state.currentModifier?.name)} /></h5>
            <button type="button" className="btn-close" onClick={closeEditModal}></button>
          </div>

          <div className="scroll-hint text-muted small text-center mt-1 mb-0">
            ⬇ {t("scrolltoupdatemore")}
          </div>

          <div className="modal-body">
            <form>
              {[
               { label: `${t("English Name *")}`, name: 'nameEn', placeholder: `${t("Cheese, Spicy, etc.")}` },
{ label: `${t("Arabic Name *")}`, name: 'nameAr', placeholder: `${t("جبنة، حار، إلخ")}` },
{ label: `${t("English Description *")}`, name: 'descriptionEn', placeholder: `${t("Description in English")}` },
{ label: `${t("Arabic Description *")}`, name: 'descriptionAr', placeholder: `${t("الوصف بالعربية")}` },

              ].map((field) => (
                <div className="mb-4" key={field.name}>
                  <label className="form-label" style={{ marginBottom: '4px' }}>{field.label}</label>
                  <input
                    type="text"
                    name={field.name}
                    value={state.editOption[field.name]}
                    onChange={handleEditOptionInputChange}
                    className={`form-control mb-1 ${state.errors?.[field.name] ? "is-invalid" : ""}`}
                    required
                    pattern=".*\\S.*"
                    title="Cannot be only spaces"
                    placeholder={field.placeholder}
                  />
                  <div className="invalid-feedback d-block form-error-placeholder">
                    {state.errors?.[field.name] || '\u00A0'}
                  </div>
                </div>
              ))}

              <div className="row">
                <div className="col-md-6 mb-4">
                  <label className="form-label" style={{ marginBottom: '4px' }}>{t("price")} (SAR) *</label>
                  <input
                    type="number"
                    name="price"
                    value={state.editOption.price}
                    onChange={handleEditOptionInputChange}
                    className={`form-control mb-1 ${state.errors?.price ? "is-invalid" : ""}`}
                    required
                    min="0.01"
                    step="0.01"
                    placeholder={t("price")}
                    onKeyDown={(e) => {
                      if (['e', 'E', '+', '-'].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    style={{
                      MozAppearance: 'textfield'
                    }}
                  />
                  <div className="invalid-feedback d-block form-error-placeholder">
                    {state.errors?.price || '\u00A0'}
                  </div>
                </div>

                <div className="col-md-6 mb-4">
                  <label className="form-label" style={{ marginBottom: '4px' }}>{t("Calories")}</label>
                  <input
                    type="number"
                    name="calories"
                    value={state.editOption.calories}
                    onChange={handleEditOptionInputChange}
                    className={`form-control mb-1 ${state.errors?.calories ? "is-invalid" : ""}`}
                    required
                    min="1"
                    step="1"
                    placeholder={t("Calories")}
                    onKeyDown={(e) => {
                      if (['e', 'E', '+', '-', '.'].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    style={{
                      MozAppearance: 'textfield'
                    }}
                  />
                  <div className="invalid-feedback d-block form-error-placeholder">
                    {state.errors?.calories || '\u00A0'}
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div className="modal-footer">
            <Button type="button" color="secondary" onClick={closeEditModal}>
              {t("cancel")}
            </Button>

            <Button
              type="button"
              color="primary"
              onClick={handleEditOptionSubmit}
              disabled={state.loading}
            >
              {state.loading ? (
                <>
                  <span className="spinner-border spinner-border-sm" role="status"></span>
                  <span className="ms-2">Updating...</span>
                </>
              ) : (
                `${t("update")}`
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>

    <style>{`
.modal-custom {
  max-width: 500px;
  width: 100%;
}

.modal-dialog.modal-custom {
  margin: 1rem auto;
  width: 100%;
}

.modal-content {
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  border-radius: 0.5rem;
}

.modal-body {
  overflow-y: auto;
  flex-grow: 1;
  padding: 1rem;
}

/* Hide number input arrows */
input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

/* Scrollbar styling */
.modal-body::-webkit-scrollbar {
  width: 6px;
}
.modal-body::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 4px;
}
.modal-body {
  scrollbar-width: thin;
}

/* Backdrop with blur */
.modal-backdrop-blur {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  backdrop-filter: blur(4px);
  background-color: rgba(0, 0, 0, 0.3);
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}
.modal-backdrop-blur.fade-in {
  opacity: 1;
}
.modal-backdrop-blur.fade-out {
  opacity: 0;
}

/* Modal fade effect */
.modal.fade-custom {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  pointer-events: none;
  padding: 1rem;
}
.modal.fade-custom.fade-in {
  opacity: 1;
  pointer-events: auto;
}
.modal.fade-custom.fade-out {
  opacity: 0;
  pointer-events: none;
}

/* Mobile responsiveness */
@media (max-width: 576px) {
  .modal-dialog.modal-custom {
    max-width: 95%;
    margin: 0.5rem auto;
  }

  .modal-content {
    max-height: 85vh;
  }
}

/* Scroll hint */
.scroll-hint {
  font-size: 0.75rem;
  color: #6c757d;
}

/* Ensure space is always reserved for error messages */
.form-error-placeholder {
  min-height: 1.75em;
  font-size: 0.875em;
  color: #dc3545;
  display: block;
  margin-top: 1px; /* Added spacing below input field */
}
`}</style>
  </>
)}







      {/* Nutrition Facts Modal */}

<>
  {showNutritionModal && canEditProduct && (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div
        className="modal-content"
        dir={isArabic ? "rtl" : "ltr"}
        lang={i18n.language}
        onClick={(e) => e.stopPropagation()}
      >
        <style>{`
          .modal-overlay {
            position: fixed;
            top: 0; left: 0; right: 0; bottom: 0;
            background: rgba(0,0,0,0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 9999;
            padding: 20px;
          }
.form-input::-webkit-outer-spin-button,
.form-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Remove arrows for number inputs (Firefox) */
.form-input[type=number] {
  -moz-appearance: textfield;
}
          .modal-content {
            background: #fff;
            border-radius: 12px;
            width: 100%;
            max-width: 800px;
            max-height: 90vh;
            display: flex;
            flex-direction: column;
            overflow: hidden;
            position: relative;
          }

          .modal-header {
            padding: 24px;
            border-bottom: 1px solid #eee;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            position: relative;
            flex-shrink: 0;
          }

          .modal-title {
            font-size: 22px;
            font-weight: bold;
            margin: 0;
            text-align: start;
          }

          .modal-subtitle {
            font-size: 14px;
            color: #6c757d;
            margin-top: 4px;
            text-align: start;
          }

          .close-btn {
            background: none;
            border: none;
            font-size: 24px;
            cursor: pointer;
            line-height: 1;
          }

          .modal-body {
            padding: 24px;
            overflow-y: auto;
            max-height: cal(90vh - 160px);
          }

          .scroll-hint {
            text-align: center;
            font-size: 13px;
            color: #5f5f5fff;
            margin: 6px 0;
            flex-shrink: 0;
          }

          .nutrition-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
            gap: 16px;
            margin-bottom: 32px;
          }

          .form-group {
            display: flex;
            flex-direction: column;
          }

          .form-label {
            font-weight: 500;
            margin-bottom: 4px;
            font-size: 14px;
          }

          .form-input {
            padding: 8px;
            border: 1px solid #ccc;
            border-radius: 6px;
          }
            .form-input:focus {
  outline: none;
  border-color: #073b4c;
  box-shadow: 0 0 0 1px #073b4c;
}

.form-input::placeholder {
          font-size: 13px;
  }
.allergens-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
}
          .allergens-section {
            margin-top: 16px;
          }

          .allergens-title {
            font-size: 16px;
            font-weight: bold;
          }

          .allergens-subtitle {
            font-size: 14px;
            color: #6c757d;
            margin-bottom: 12px;
          }
            .hide-scroll-hint{
            opacity: 0;
            color: white
            }

          .allergen-checkbox-item {
            display: flex;
            align-items: center;
            border: 1px solid #eee;
            padding: 10px;
            border-radius: 6px;
            margin-bottom: 10px;
          }

          .allergen-checkbox-label {
            display: flex;
            flex-direction: column;
            font-size: 14px;
            margin-inline-start: 10px;
          }

          .allergen-name {
            font-weight: 500;
          }

          .modal-footer {
            padding: 16px 24px;
            border-top: 1px solid #eee;
            display: flex;
            justify-content: flex-end;
            gap: 12px;
            flex-shrink: 0;
            background: #fff;
          }

          
            .custom-checkbox:checked {
  accent-color: #073b4c;
}

          .btn-cancel {
            background-color: #ecececff;
          color: #000000ff;
          border: 1px solid #073b4c;
          }

          .btn-save {
            background: #073b4c;
            color: white;
          }

         .modal-button {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.spinner-container {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.spinner {
  border: 2px solid #f3f3f3;
  border-top: 2px solid #073b4c;
  border-radius: 50%;
  width: 14px;
  height: 14px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

          @media (max-width: 480px) {
            .form-input {
              width: 100%;
            }
          }
        `}</style>

       <div className="modal-header">
          <div className="d-flex justify-content-between w-100"> <h2 className="modal-title">{t("managenutritionfacts")}</h2>  <button
    className={`close-btn`}
    onClick={handleModalClose}
  >
    &times;
  </button></div>
  <p className="modal-subtitle">
    {t("updatethenutrionalinformationforyouitems")}
  </p>

</div>


        <div ref={setModalBodyEl} className="modal-body">
          <h3 className="allergens-title">{t("nutritionfacts")}</h3>
            <p className="allergens-subtitle">{t("managequantityofnutrients")}</p>
     <div className="nutrition-grid">
      
  {nutritionFields.map((field) => {
   
    
    
      
    return (
      
      <div className="form-group" key={field.name}>
        <label className="form-label">
          {t(field.displayName)}
          {field.unit && ` (${field.unit})`}
        </label>
      <input
  type="text"
  inputMode="decimal"
  min={field.min}
  max={field.max}
  step="0.0001"
  name={field.name}
  value={
    nutritionFacts[field.name] === null ||
    nutritionFacts[field.name] === undefined ||
    nutritionFacts[field.name] === "" ||
    nutritionFacts[field.name] === 0
      ? ""
      : nutritionFacts[field.name]
  }
 placeholder={
    nutritionFacts[field.name] === null ||
    nutritionFacts[field.name] === undefined ||
    nutritionFacts[field.name] === "" ||
    nutritionFacts[field.name] === 0
      ? `${t(field.description)} (${field.min} - ${field.max})`
      : ""
  }
  className="form-input"
 onChange={(e) => {
    const value = e.target.value;

    // Allow only numbers with up to 4 decimal places (no negatives, no letters)
    const regex = /^(?:\d+(\.\d{0,4})?)?$/;

    if (value === "" || regex.test(value)) {
      const integerDigits = value.split(".")[0];
      const maxIntegerLength = field.max.toString().length;

      if (integerDigits.length <= maxIntegerLength) {
        setNutritionFacts((prev) => ({
          ...prev,
          [field.name]: value === "" ? "" : value
        }));
      }
    }
  }}
  onPaste={(e) => {
    const pastedData = e.clipboardData.getData("text");
    const regex = /^(?:\d+(\.\d{0,4})?)?$/;

    if (!regex.test(pastedData)) {
      e.preventDefault(); // Block paste if invalid
    }
  }}
  onKeyDown={(e) => {
    // Block minus sign, 'e', and other invalid chars
    if (["-", "+", "e", "E"].includes(e.key)) {
      e.preventDefault();
    }
  }}
/>

      </div>
    );
  })}
</div>

          <div className="allergens-section">
            <h3 className="allergens-title">{t("allergens")}</h3>
            <p className="allergens-subtitle">{t("selectallallergenspresentintheitem")}</p>

            {allergens.length === 0 ? (
              <div style={{ color: '#666', fontStyle: 'italic' }}>
                {t("No allergens found.")}
              </div>
            ) : (
             <div className="allergens-grid">
  {allergens.map((allergen) => (
  <div
  key={allergen._id}
  className="allergen-checkbox-item"
  onClick={() => handleAllergenCheckbox(allergen.external_id)}
  style={{ cursor: 'pointer', userSelect: 'none', border: nutritionFacts.allergen_ids.includes(allergen.external_id)
      ? '1px solid #073b4c'
      : '1px solid #ccc', }}
>
  <input
    type="checkbox"
    className="allergen-checkbox custom-checkbox"
    id={`allergen-${allergen._id}`}
    checked={nutritionFacts.allergen_ids.includes(allergen.external_id)}
    readOnly
    style={{ pointerEvents: 'none' }} // prevent direct interaction
  />
  <label className="allergen-checkbox-label">
    <div className="allergen-name">{localizedAllergenLabel(allergen)}</div>
  </label>
</div>

  ))}
</div>
            )}
          </div>
        </div>

     
  <div className={`scroll-hint ${atBottom ? "hide-scroll-hint" : ""}`}>
    <MoveDown size={12} style={{ color: '#5f5f5fff' }} /> {t("scrolltoupdatemore")}
  </div>


        <div className="modal-footer">
          <Button color="secondary" onClick={() => setShowNutritionModal(false)}>
            {t("cancel")}
          </Button>
          <Button
            color="primary"
            onClick={handleSaveNutrition}
            disabled={nutritionLoading}
          >
            {nutritionLoading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" />
                {t("saving")}
              </>
            ) : (
              `${t("savechanges")}`
            )}
          </Button>
        </div>
      </div>
    </div>
  )}
</>




  

    
  

      {/* Edit Availability Modal */}
<Modal
  show={Boolean(showEditAvailabilityModal && canEditProduct)}
  onHide={() => setShowEditAvailabilityModal(false)}
  size="lg"
  centered
  backdrop="static"
  className="availability-modal p-0"
>
  <Modal.Header closeButton className="border-0 pb-0">
    <Modal.Title className="h4 fw-bold text-dark">
      <i className="bi bi-calendar-week me-2"></i>
      {t("editavailabilityschedule")}
    </Modal.Title>
  </Modal.Header>

  <Modal.Body className="px-4 py-3 overflow-auto" style={{ maxHeight: "75vh" }}>
    <div className="row g-3">
      {editAvailability &&
        Object.entries(editAvailability).map(([day, details]) => (
          <div key={day} className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-body p-3">
                {/* Day Header */}
                <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between mb-3">
                  <div className="d-flex align-items-center mb-2 mb-md-0">
                    <div className="day-indicator me-3">
                      <div className={`day-circle ${details.is_visible ? "active" : "inactive"}`}>
                        {t(day.charAt(0))}
                      </div>
                    </div>
                    <div>
                      <h6 className="mb-0 fw-semibold text-dark">
                        {t(day)}
                      </h6>
                      <small className="text-muted">
                        {details.times.length} {t("time slot")}
                      </small>
                    </div>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <Form.Check
                      type="switch"
                      id={`switch-${day}`}
                      label={t("Available")}
                      checked={details.is_visible}
                      onChange={(e) =>
                        handleAvailabilityChange(day, "is_visible", e.target.checked)
                      }
                      className="availability-switch"
                    />
                    <Button
                      size="sm"
                      variant="outline-primary"
                      onClick={() => handleAddTimeRange(day)}
                      className="add-time-btn"
                      disabled={!details.is_visible}
                    >
                      <i className="bi bi-plus-circle me-1"></i>
                      <span className="d-none d-sm-inline">{t("addtime")}</span>
                      <span className="d-sm-none">{t("add")}</span>
                    </Button>
                  </div>
                </div>

                {/* Time Slots Grid */}
<div className={`${!details.is_visible ? "opacity-50" : ""}`}>
  <div className="row g-2">
    {details.times.map((time, idx) => (
      <div key={idx} className="col-12 p-0">
        <div className="time-slot-container h-100">
          <div className="d-flex flex-column bg-light p-2 rounded border border-success-subtle h-100">
            <div className="d-flex flex-wrap justify-content-between align-items-end gap-3 w-100 overflow-auto time-row-wrapper">
              {/* Time Inputs */}
              <div className="d-flex gap-1 flex-wrap time-input-wrapper">
                <div className="time-input-group">
                  <label className="form-label small text-muted mb-1">{t("Start")}</label>
                  <Form.Control
                    type="time"
                    value={time.start}
                    onChange={(e) =>
                      handleAvailabilityChange(
                        day,
                        "time",
                        { key: "start", val: e.target.value },
                        idx
                      )
                    }
                    className="time-input fixed-time-width"
                    disabled={!details.is_visible}
                  />
                </div>
                <div className="time-input-group">
                  <label className="form-label small text-muted mb-1">{t("end")}</label>
                  <Form.Control
                    type="time"
                    value={time.end}
                    onChange={(e) =>
                      handleAvailabilityChange(
                        day,
                        "time",
                        { key: "end", val: e.target.value },
                        idx
                      )
                    }
                    className="time-input fixed-time-width"
                    disabled={!details.is_visible}
                  />
                </div>
              </div>

              {/* Delete Button */}
              {details.times.length > 1 && (
                <div className="text-end flex-shrink-0 delete-btn-container">
                  <Button
                    size="sm"
                    style={{ height: "34px" }}
                    variant="outline-danger"
                    onClick={() => handleRemoveTimeRange(day, idx)}
                    className="remove-btn d-flex align-items-center"
                    disabled={!details.is_visible}
                  >
                    <i className="bi bi-trash3"></i>
                    <span className="ms-1 remove-text">{t("remove")}</span>
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>

  <style>{`
    .fixed-time-width {
      width: 140px;
    }

    @media (max-width: 576px) {
      .fixed-time-width {
        width: 130px;
      }
    }

    @media (max-width: 992px) {
      .remove-text {
        display: none;
      }
      .delete-btn-container .remove-btn {
        padding: 0.8rem;
      }
    }

    @media (max-width: 446px) {
      .time-row-wrapper {
        flex-direction: column;
        align-items: stretch;
      }

      .time-input-wrapper {
        width: 100%;
        gap: 0;
      }

      .time-input-group {
        width: 49%;
      }

      .delete-btn-container {
        width: 100%;
        margin-top: 8px;
      }

      .delete-btn-container .remove-btn {
        width: 100%;
        justify-content: center;
        padding: 0.25rem 0.5rem;
      }

      .remove-text {
        display: inline;
      }

      .fixed-time-width {
        width: 100% !important;
      }
    }
  `}</style>
</div>







              </div>
            </div>
          </div>
        ))}
    </div>
  </Modal.Body>

  <Modal.Footer className="border-0 pt-0 px-4 pb-4">
    <div className="d-flex gap-2 w-100 justify-content-end">
      <Button
        variant="outline-secondary"
        onClick={() => setShowEditAvailabilityModal(false)}
        className="px-4"
      >
        <i className="bi bi-x-circle me-1"></i>
        {t("cancel")}
      </Button>
      <Button
        variant="primary"
        onClick={handleSaveAvailability}
        className="px-4"
        disabled={availabilityLoading}
      >
        {availabilityLoading ? (
          <>
            <span
              className="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
            {t("saving")}
          </>
        ) : (
          <>
            <i className="bi bi-check-circle me-1"></i>
            {t("savechanges")}
          </>
        )}
      </Button>
    </div>
  </Modal.Footer>

  <style jsx>{`
    .availability-modal .modal-content {
      border: none;
      border-radius: 16px;
      box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
        0 10px 10px -5px rgba(0, 0, 0, 0.04);
    }

    .availability-modal .modal-header {
      background: #fff;
      border-radius: 16px 16px 0 0;
    }

    .day-indicator {
      position: relative;
    }

    .day-circle {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      font-size: 16px;
    }

    .day-circle.active {
      background: linear-gradient(135deg, rgb(0, 5, 94), rgb(7, 1, 125));
      color: white;
      box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
    }

    .day-circle.inactive {
      background: #f8f9fa;
      color: #6c757d;
      border: 2px solid #dee2e6;
    }

    .add-time-btn {
      border-radius: 8px;
      font-weight: 500;
    }

    .add-time-btn:hover:not(:disabled) {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
    }

    .time-slot-container {
      transition: all 0.3s ease;
    }

    .time-slot-container:hover {
      transform: translateY(-1px);
    }

    .time-input {
      border-radius: 8px;
      border: 1px solid #ced4da;
    }

    .time-input:focus {
      border-color: #007bff;
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }

    .remove-btn {
      border-radius: 8px;
    }

    .availability-switch .form-check-input:checked {
      background-color: #001f5b;
      border-color: #001f5b;
    }

    @media (max-width: 767.98px) {
      .time-inputs {
        flex-direction: column;
      }
    }
  `}</style>
</Modal>




      {/* Catalogs Section at the bottom */}
      {Array.isArray(product.catalogs) && product.catalogs.length > 0 && (
        <div className="product-associated-catalogs mb-4 mt-4">
          <h3 className="product-associated-catalogs__title">
            {t("associatedcatalogs")}
          </h3>
          <DataTable
            tableId="product-associated-catalogs"
            className="product-associated-catalogs-table"
            columns={associatedCatalogColumns}
            data={product.catalogs}
            rowKey="catalogId"
            hideToolbar
            hideFooter
            showColumnSettings={false}
          />
        </div>
      )}
      <DeleteModal 
        text={t("Are you sure you want to remove this product from the selected catalog?")} 
        showModal={Boolean(showDeleteModal && canMutateCatalogLink)} 
        confirmDelete={() => {
          handleRemoveFromCatalog(selectedCatalogId);
          setShowDeleteModal(false);
          setSelectedCatalogId(null);
        }} 
        onClose={() => setShowDeleteModal(false)} 
      />
    </MDBContainer>
  );
};

export default Product;
